(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2265],{

/***/ 54524:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ Query; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88802);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7862);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _hooks_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12951);



function Query(props) {
    var children = props.children, query = props.query, options = (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__rest)(props, ["children", "query"]);
    var result = (0,_hooks_index_js__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)(query, options);
    return children && result ? children(result) : null;
}
Query.propTypes = {
    client: prop_types__WEBPACK_IMPORTED_MODULE_2__.object,
    children: prop_types__WEBPACK_IMPORTED_MODULE_2__.func.isRequired,
    fetchPolicy: prop_types__WEBPACK_IMPORTED_MODULE_2__.string,
    notifyOnNetworkStatusChange: prop_types__WEBPACK_IMPORTED_MODULE_2__.bool,
    onCompleted: prop_types__WEBPACK_IMPORTED_MODULE_2__.func,
    onError: prop_types__WEBPACK_IMPORTED_MODULE_2__.func,
    pollInterval: prop_types__WEBPACK_IMPORTED_MODULE_2__.number,
    query: prop_types__WEBPACK_IMPORTED_MODULE_2__.object.isRequired,
    variables: prop_types__WEBPACK_IMPORTED_MODULE_2__.object,
    ssr: prop_types__WEBPACK_IMPORTED_MODULE_2__.bool,
    partialRefetch: prop_types__WEBPACK_IMPORTED_MODULE_2__.bool,
    returnPartialData: prop_types__WEBPACK_IMPORTED_MODULE_2__.bool
};
//# sourceMappingURL=Query.js.map

/***/ }),

/***/ 21742:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
 Highcharts JS v10.3.3 (2023-01-20)

 Annotations module

 (c) 2009-2021 Torstein Honsi

 License: www.highcharts.com/license
*/
(function(c){ true&&module.exports?(c["default"]=c,module.exports=c): true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(88231)], __WEBPACK_AMD_DEFINE_RESULT__ = (function(r){c(r);c.Highcharts=r;return c}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):0})(function(c){function r(c,l,w,m){c.hasOwnProperty(l)||(c[l]=m.apply(null,w),"function"===typeof CustomEvent&&window.dispatchEvent(new CustomEvent("HighchartsModuleLoaded",{detail:{path:l,module:c[l]}})))}c=c?c._modules:{};
r(c,"Extensions/Annotations/AnnotationChart.js",[c["Core/Utilities.js"]],function(c){function l(a,d){a=this.initAnnotation(a);this.options.annotations.push(a.options);C(d,!0)&&(a.redraw(),a.graphic.attr({opacity:1}));return a}function p(){var a=this;a.plotBoxClip=this.renderer.clipRect(this.plotBox);a.controlPointsGroup=a.renderer.g("control-points").attr({zIndex:99}).clip(a.plotBoxClip).add();a.options.annotations.forEach(function(d,g){if(!a.annotations.some(function(a){return a.options===d})){var b=
a.initAnnotation(d);a.options.annotations[g]=b.options}});a.drawAnnotations();b(a,"redraw",a.drawAnnotations);b(a,"destroy",function(){a.plotBoxClip.destroy();a.controlPointsGroup.destroy()});b(a,"exportData",function(d){var g=(this.options.exporting&&this.options.exporting.csv||{}).columnHeaderFormatter,b=!d.dataRows[1].xValues,e=a.options.lang&&a.options.lang.exportData&&a.options.lang.exportData.annotationHeader,h=function(a){if(g){var d=g(a);if(!1!==d)return d}d=e+" "+a;return b?{columnTitle:d,
topLevelColumnTitle:d}:d},f=d.dataRows[0].length,C=a.options.exporting&&a.options.exporting.csv&&a.options.exporting.csv.annotations&&a.options.exporting.csv.annotations.itemDelimiter,q=a.options.exporting&&a.options.exporting.csv&&a.options.exporting.csv.annotations&&a.options.exporting.csv.annotations.join;a.annotations.forEach(function(a){a.options.labelOptions&&a.options.labelOptions.includeInDataExport&&a.labels.forEach(function(a){if(a.options.text){var g=a.options.text;a.points.forEach(function(a){var b=
a.x,e=a.series.xAxis?a.series.xAxis.options.index:-1,h=!1;if(-1===e){a=d.dataRows[0].length;for(var n=Array(a),c=0;c<a;++c)n[c]="";n.push(g);n.xValues=[];n.xValues[e]=b;d.dataRows.push(n);h=!0}h||d.dataRows.forEach(function(a){!h&&a.xValues&&void 0!==e&&b===a.xValues[e]&&(q&&a.length>f?a[a.length-1]+=C+g:a.push(g),h=!0)});if(!h){a=d.dataRows[0].length;n=Array(a);for(c=0;c<a;++c)n[c]="";n[0]=b;n.push(g);n.xValues=[];void 0!==e&&(n.xValues[e]=b);d.dataRows.push(n)}})}})});var c=0;d.dataRows.forEach(function(a){c=
Math.max(c,a.length)});for(var t=c-d.dataRows[0].length,D=0;D<t;D++){var A=h(D+1);b?(d.dataRows[0].push(A.topLevelColumnTitle),d.dataRows[1].push(A.columnTitle)):d.dataRows[0].push(A)}})}function m(){this.plotBoxClip.attr(this.plotBox);this.annotations.forEach(function(a){a.redraw();a.graphic.animate({opacity:1},a.animationConfig)})}function k(a){var b=this.annotations,h="annotations"===a.coll?a:d(b,function(d){return d.options.id===a});h&&(g(h,"remove"),e(this.options.annotations,h.options),e(b,
h),h.destroy())}function f(){this.annotations=[];this.options.annotations||(this.options.annotations=[])}function a(a){this.chart.hasDraggedAnnotation||a.apply(this,Array.prototype.slice.call(arguments,1))}var b=c.addEvent,e=c.erase,d=c.find,g=c.fireEvent,C=c.pick,D=c.wrap,A=[],q;(function(d){d.compose=function(d,g,e){-1===A.indexOf(g)&&(A.push(g),b(g,"afterInit",f),g=g.prototype,g.addAnnotation=l,g.callbacks.push(p),g.collectionsWithInit.annotations=[l],g.collectionsWithUpdate.push("annotations"),
g.drawAnnotations=m,g.removeAnnotation=k,g.initAnnotation=function(a){a=new (d.types[a.type]||d)(this,a);this.annotations.push(a);return a});-1===A.indexOf(e)&&(A.push(e),D(e.prototype,"onContainerMouseDown",a))}})(q||(q={}));return q});r(c,"Extensions/Annotations/AnnotationDefaults.js",[c["Core/Utilities.js"]],function(c){var l=c.defined;return{visible:!0,animation:{},crop:!0,draggable:"xy",labelOptions:{align:"center",allowOverlap:!1,backgroundColor:"rgba(0, 0, 0, 0.75)",borderColor:"#000000",borderRadius:3,
borderWidth:1,className:"highcharts-no-tooltip",crop:!1,formatter:function(){return l(this.y)?""+this.y:"Annotation label"},includeInDataExport:!0,overflow:"justify",padding:5,shadow:!1,shape:"callout",style:{fontSize:"11px",fontWeight:"normal",color:"contrast"},useHTML:!1,verticalAlign:"bottom",x:0,y:-16},shapeOptions:{stroke:"rgba(0, 0, 0, 0.75)",strokeWidth:1,fill:"rgba(0, 0, 0, 0.75)",r:0,snap:2},controlPointOptions:{events:{},style:{cursor:"pointer",fill:"#ffffff",stroke:"#000000","stroke-width":2},
height:10,symbol:"circle",visible:!1,width:10},events:{},zIndex:6}});r(c,"Extensions/Annotations/EventEmitter.js",[c["Core/Globals.js"],c["Core/Utilities.js"]],function(c,l){var p=c.doc,m=c.isTouchDevice,k=l.addEvent,f=l.fireEvent,a=l.objectEach,b=l.pick,e=l.removeEvent;return function(){function d(){}d.prototype.addEvents=function(){var d=this,b=function(a){k(a,m?"touchstart":"mousedown",function(a){d.onMouseDown(a)},{passive:!1})};b(this.graphic.element);(d.labels||[]).forEach(function(a){a.options.useHTML&&
a.graphic.text&&b(a.graphic.text.element)});a(d.options.events,function(a,b){var e=function(e){"click"===b&&d.cancelClick||a.call(d,d.chart.pointer.normalize(e),d.target)};if(-1===(d.nonDOMEvents||[]).indexOf(b))d.graphic.on(b,e);else k(d,b,e,{passive:!1})});if(d.options.draggable&&(k(d,"drag",d.onDrag),!d.graphic.renderer.styledMode)){var e={cursor:{x:"ew-resize",y:"ns-resize",xy:"move"}[d.options.draggable]};d.graphic.css(e);(d.labels||[]).forEach(function(a){a.options.useHTML&&a.graphic.text&&
a.graphic.text.css(e)})}d.isUpdating||f(d,"add")};d.prototype.destroy=function(){this.removeDocEvents();e(this);this.hcEvents=null};d.prototype.mouseMoveToRadians=function(a,d,b){var e=a.prevChartY-b,g=a.prevChartX-d;b=a.chartY-b;a=a.chartX-d;this.chart.inverted&&(d=g,g=e,e=d,d=a,a=b,b=d);return Math.atan2(b,a)-Math.atan2(e,g)};d.prototype.mouseMoveToScale=function(a,d,b){d=(a.chartX-d||1)/(a.prevChartX-d||1);a=(a.chartY-b||1)/(a.prevChartY-b||1);this.chart.inverted&&(b=a,a=d,d=b);return{x:d,y:a}};
d.prototype.mouseMoveToTranslation=function(a){var d=a.chartX-a.prevChartX;a=a.chartY-a.prevChartY;if(this.chart.inverted){var b=a;a=d;d=b}return{x:d,y:a}};d.prototype.onDrag=function(a){if(this.chart.isInsidePlot(a.chartX-this.chart.plotLeft,a.chartY-this.chart.plotTop,{visiblePlotOnly:!0})){var d=this.mouseMoveToTranslation(a);"x"===this.options.draggable&&(d.y=0);"y"===this.options.draggable&&(d.x=0);this.points.length?this.translate(d.x,d.y):(this.shapes.forEach(function(a){return a.translate(d.x,
d.y)}),this.labels.forEach(function(a){return a.translate(d.x,d.y)}));this.redraw(!1)}};d.prototype.onMouseDown=function(a){a.preventDefault&&a.preventDefault();if(2!==a.button){var d=this,e=d.chart.pointer;a=e.normalize(a);var g=a.chartX,c=a.chartY;d.cancelClick=!1;d.chart.hasDraggedAnnotation=!0;d.removeDrag=k(p,m?"touchmove":"mousemove",function(a){d.hasDragged=!0;a=e.normalize(a);a.prevChartX=g;a.prevChartY=c;f(d,"drag",a);g=a.chartX;c=a.chartY},m?{passive:!1}:void 0);d.removeMouseUp=k(p,m?"touchend":
"mouseup",function(a){var e=b(d.target&&d.target.annotation,d.target);e&&(e.cancelClick=d.hasDragged);d.cancelClick=d.hasDragged;d.hasDragged=!1;d.chart.hasDraggedAnnotation=!1;f(b(e,d),"afterUpdate");d.onMouseUp(a)},m?{passive:!1}:void 0)}};d.prototype.onMouseUp=function(a){var d=this.chart;a=this.target||this;var b=d.options.annotations;d=d.annotations.indexOf(a);this.removeDocEvents();b[d]=a.options};d.prototype.removeDocEvents=function(){this.removeDrag&&(this.removeDrag=this.removeDrag());this.removeMouseUp&&
(this.removeMouseUp=this.removeMouseUp())};return d}()});r(c,"Extensions/Annotations/ControlPoint.js",[c["Extensions/Annotations/EventEmitter.js"],c["Core/Utilities.js"]],function(c,l){var p=this&&this.__extends||function(){var f=function(a,b){f=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(a,d){a.__proto__=d}||function(a,d){for(var b in d)d.hasOwnProperty(b)&&(a[b]=d[b])};return f(a,b)};return function(a,b){function e(){this.constructor=a}f(a,b);a.prototype=null===b?Object.create(b):
(e.prototype=b.prototype,new e)}}(),m=l.merge,k=l.pick;c=function(f){function a(a,e,d,g){var b=f.call(this)||this;b.graphic=void 0;b.nonDOMEvents=["drag"];b.chart=a;b.target=e;b.options=d;b.index=k(d.index,g);return b}p(a,f);a.prototype.destroy=function(){f.prototype.destroy.call(this);this.graphic&&(this.graphic=this.graphic.destroy());this.options=this.target=this.chart=null};a.prototype.redraw=function(a){this.graphic[a?"animate":"attr"](this.options.positioner.call(this,this.target))};a.prototype.render=
function(){var a=this.chart,e=this.options;this.graphic=a.renderer.symbol(e.symbol,0,0,e.width,e.height).add(a.controlPointsGroup).css(e.style);this.setVisibility(e.visible);this.addEvents()};a.prototype.setVisibility=function(a){this.graphic[a?"show":"hide"]();this.options.visible=a};a.prototype.update=function(a){var b=this.chart,d=this.target,g=this.index;a=m(!0,this.options,a);this.destroy();this.constructor(b,d,a,g);this.render(b.controlPointsGroup);this.redraw()};return a}(c);"";return c});
r(c,"Extensions/Annotations/MockPoint.js",[c["Core/Series/SeriesRegistry.js"],c["Core/Utilities.js"]],function(c,l){var p=c.series.prototype,m=l.defined,k=l.fireEvent;c=function(){function f(a,b,e){this.plotY=this.plotX=void 0;this.mock=!0;this.series={visible:!0,chart:a,getPlotBox:p.getPlotBox};this.target=b||null;this.options=e;this.applyOptions(this.getOptions())}f.fromPoint=function(a){return new f(a.series.chart,null,{x:a.x,y:a.y,xAxis:a.series.xAxis,yAxis:a.series.yAxis})};f.pointToPixels=function(a,
b){var e=a.series,d=e.chart,g=a.plotX||0,f=a.plotY||0;d.inverted&&(a.mock?(g=a.plotY,f=a.plotX):(g=d.plotWidth-(a.plotY||0),f=d.plotHeight-(a.plotX||0)));e&&!b&&(a=e.getPlotBox(),g+=a.translateX,f+=a.translateY);return{x:g,y:f}};f.pointToOptions=function(a){return{x:a.x,y:a.y,xAxis:a.series.xAxis,yAxis:a.series.yAxis}};f.prototype.applyOptions=function(a){this.command=a.command;this.setAxis(a,"x");this.setAxis(a,"y");this.refresh()};f.prototype.getLabelConfig=function(){return{x:this.x,y:this.y,point:this}};
f.prototype.getOptions=function(){return this.hasDynamicOptions()?this.options(this.target):this.options};f.prototype.hasDynamicOptions=function(){return"function"===typeof this.options};f.prototype.isInsidePlot=function(){var a=this.plotX,b=this.plotY,e=this.series.xAxis,d=this.series.yAxis,g={x:a,y:b,isInsidePlot:!0,options:{}};e&&(g.isInsidePlot=m(a)&&0<=a&&a<=e.len);d&&(g.isInsidePlot=g.isInsidePlot&&m(b)&&0<=b&&b<=d.len);k(this.series.chart,"afterIsInsidePlot",g);return g.isInsidePlot};f.prototype.refresh=
function(){var a=this.series,b=a.xAxis;a=a.yAxis;var e=this.getOptions();b?(this.x=e.x,this.plotX=b.toPixels(e.x,!0)):(this.x=void 0,this.plotX=e.x);a?(this.y=e.y,this.plotY=a.toPixels(e.y,!0)):(this.y=null,this.plotY=e.y);this.isInside=this.isInsidePlot()};f.prototype.refreshOptions=function(){var a=this.series,b=a.xAxis;a=a.yAxis;this.x=this.options.x=b?this.options.x=b.toValue(this.plotX,!0):this.plotX;this.y=this.options.y=a?a.toValue(this.plotY,!0):this.plotY};f.prototype.rotate=function(a,b,
e){if(!this.hasDynamicOptions()){var d=Math.cos(e);e=Math.sin(e);var g=this.plotX-a,f=this.plotY-b;this.plotX=g*d-f*e+a;this.plotY=g*e+f*d+b;this.refreshOptions()}};f.prototype.scale=function(a,b,e,d){if(!this.hasDynamicOptions()){var g=this.plotY*d;this.plotX=(1-e)*a+this.plotX*e;this.plotY=(1-d)*b+g;this.refreshOptions()}};f.prototype.setAxis=function(a,b){b+="Axis";a=a[b];var e=this.series.chart;this.series[b]="object"===typeof a?a:m(a)?e[b][a]||e.get(a):null};f.prototype.toAnchor=function(){var a=
[this.plotX,this.plotY,0,0];this.series.chart.inverted&&(a[0]=this.plotY,a[1]=this.plotX);return a};f.prototype.translate=function(a,b,e,d){this.hasDynamicOptions()||(this.plotX+=e,this.plotY+=d,this.refreshOptions())};return f}();"";return c});r(c,"Extensions/Annotations/Controllables/Controllable.js",[c["Extensions/Annotations/ControlPoint.js"],c["Extensions/Annotations/MockPoint.js"],c["Core/Tooltip.js"],c["Core/Utilities.js"]],function(c,l,w,m){var k=m.isObject,f=m.isString,a=m.merge,b=m.splat;
m=function(){function e(a,b,e,f){this.graphic=void 0;this.annotation=a;this.chart=a.chart;this.collection="label"===f?"labels":"shapes";this.options=b;this.points=[];this.controlPoints=[];this.index=e;this.itemType=f;this.init(a,b,e)}e.prototype.addControlPoints=function(){var d=this,b=this.controlPoints,e=this.options.controlPoints||[];e.forEach(function(f,g){f=a(d.options.controlPointOptions,f);f.index||(f.index=g);e[g]=f;b.push(new c(d.chart,d,f))})};e.prototype.anchor=function(d){var b=d.series.getPlotBox(),
e=d.series.chart,f=d.mock?d.toAnchor():w.prototype.getAnchor.call({chart:d.series.chart},d);f={x:f[0]+(this.options.x||0),y:f[1]+(this.options.y||0),height:f[2]||0,width:f[3]||0};return{relativePosition:f,absolutePosition:a(f,{x:f.x+(d.mock?b.translateX:e.plotLeft),y:f.y+(d.mock?b.translateY:e.plotTop)})}};e.prototype.attr=function(){for(var a=0;a<arguments.length;a++);this.graphic.attr.apply(this.graphic,arguments)};e.prototype.attrsFromOptions=function(a){var d=this.constructor.attrsMap,b={},e=
this.chart.styledMode,f;for(f in a){var c=d[f];"undefined"===typeof d[f]||e&&-1!==["fill","stroke","stroke-width"].indexOf(c)||(b[c]=a[f])}return b};e.prototype.destroy=function(){this.graphic&&(this.graphic=this.graphic.destroy());this.tracker&&(this.tracker=this.tracker.destroy());this.controlPoints.forEach(function(a){return a.destroy()});this.options=this.controlPoints=this.points=this.chart=null;this.annotation&&(this.annotation=null)};e.prototype.getPointsOptions=function(){var a=this.options;
return a.points||a.point&&b(a.point)};e.prototype.init=function(a,b,e){this.annotation=a;this.chart=a.chart;this.options=b;this.points=[];this.controlPoints=[];this.index=e;this.linkPoints();this.addControlPoints()};e.prototype.linkPoints=function(){var a=this.getPointsOptions(),b=this.points,e=a&&a.length||0,f;for(f=0;f<e;f++){var c=this.point(a[f],b[f]);if(!c){b.length=0;return}c.mock&&c.refresh();b[f]=c}return b};e.prototype.point=function(a,b){if(a&&a.series)return a;b&&null!==b.series||(k(a)?
b=new l(this.chart,this,a):f(a)?b=this.chart.get(a)||null:"function"===typeof a&&(b=a.call(b,this),b=b.series?b:new l(this.chart,this,a)));return b};e.prototype.render=function(a){this.controlPoints.forEach(function(a){return a.render()})};e.prototype.redraw=function(a){this.controlPoints.forEach(function(d){return d.redraw(a)})};e.prototype.rotate=function(a,b,e){this.transform("rotate",a,b,e)};e.prototype.scale=function(a,b,e,f){this.transform("scale",a,b,e,f)};e.prototype.setControlPointsVisibility=
function(a){this.controlPoints.forEach(function(b){b.setVisibility(a)})};e.prototype.shouldBeDrawn=function(){return!!this.points.length};e.prototype.transform=function(a,b,e,f,c){var d=this;if(this.chart.inverted){var h=b;b=e;e=h}this.points.forEach(function(h,g){return d.transformPoint(a,b,e,f,c,g)},this)};e.prototype.transformPoint=function(a,b,e,f,c,q){var d=this.points[q];d.mock||(d=this.points[q]=l.fromPoint(d));d[a](b,e,f,c)};e.prototype.translate=function(a,b){this.transform("translate",null,
null,a,b)};e.prototype.translatePoint=function(a,b,e){this.transformPoint("translate",null,null,a,b,e)};e.prototype.translateShape=function(a,b,e){var d=this.annotation.chart,f=this.annotation.userOptions,c=d.annotations.indexOf(this.annotation);d=d.options.annotations[c];this.translatePoint(a,b,0);e&&this.translatePoint(a,b,1);d[this.collection][this.index].point=this.options.point;f[this.collection][this.index].point=this.options.point};e.prototype.update=function(b){var d=this.annotation;b=a(!0,
this.options,b);var e=this.graphic.parentGroup;this.destroy();this.constructor(d,b,this.index,this.itemType);this.render(e);this.redraw()};return e}();"";return m});r(c,"Extensions/Annotations/Controllables/ControllableDefaults.js",[],function(){return{defaultMarkers:{arrow:{tagName:"marker",attributes:{id:"arrow",refY:5,refX:9,markerWidth:10,markerHeight:10},children:[{tagName:"path",attributes:{d:"M 0 0 L 10 5 L 0 10 Z","stroke-width":0}}]},"reverse-arrow":{tagName:"marker",attributes:{id:"reverse-arrow",
refY:5,refX:1,markerWidth:10,markerHeight:10},children:[{tagName:"path",attributes:{d:"M 0 5 L 10 0 L 10 10 Z","stroke-width":0}}]}}}});r(c,"Extensions/Annotations/Controllables/ControllablePath.js",[c["Extensions/Annotations/Controllables/Controllable.js"],c["Extensions/Annotations/Controllables/ControllableDefaults.js"],c["Core/Globals.js"],c["Core/Utilities.js"]],function(c,l,w,m){function k(a){return function(b){this.attr(a,"url(#"+b+")")}}function f(){this.options.defs=D(e,this.options.defs||
{})}function a(a,b){var d={attributes:{id:a}},e={stroke:b.color||"none",fill:b.color||"rgba(0, 0, 0, 0.75)"};d.children=b.children&&b.children.map(function(a){return D(e,a)});b=D(!0,{attributes:{markerWidth:20,markerHeight:20,refX:0,refY:0,orient:"auto"}},b,d);b=this.definition(b);b.id=a;return b}var b=this&&this.__extends||function(){var a=function(b,d){a=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(a,b){a.__proto__=b}||function(a,b){for(var d in b)b.hasOwnProperty(d)&&(a[d]=b[d])};
return a(b,d)};return function(b,d){function e(){this.constructor=b}a(b,d);b.prototype=null===d?Object.create(d):(e.prototype=d.prototype,new e)}}(),e=l.defaultMarkers,d=m.addEvent,g=m.defined,C=m.extend,D=m.merge,A=m.uniqueKey,q=[],h=k("marker-end"),t=k("marker-start"),F="rgba(192,192,192,"+(w.svg?.0001:.002)+")";return function(e){function c(a,b,d){a=e.call(this,a,b,d,"shape")||this;a.type="path";return a}b(c,e);c.compose=function(b,e){-1===q.indexOf(b)&&(q.push(b),d(b,"afterGetContainer",f));-1===
q.indexOf(e)&&(q.push(e),e.prototype.addMarker=a)};c.prototype.toD=function(){var a=this.options.d;if(a)return"function"===typeof a?a.call(this):a;a=this.points;var b=a.length,d=[],e=b,f=a[0],c=e&&this.anchor(f).absolutePosition,h=0;if(c)for(d.push(["M",c.x,c.y]);++h<b&&e;)f=a[h],e=f.command||"L",c=this.anchor(f).absolutePosition,"M"===e?d.push([e,c.x,c.y]):"L"===e?d.push([e,c.x,c.y]):"Z"===e&&d.push([e]),e=f.series.visible;return e&&this.graphic?this.chart.renderer.crispLine(d,this.graphic.strokeWidth()):
null};c.prototype.shouldBeDrawn=function(){return e.prototype.shouldBeDrawn.call(this)||!!this.options.d};c.prototype.render=function(a){var b=this.options,d=this.attrsFromOptions(b);this.graphic=this.annotation.chart.renderer.path([["M",0,0]]).attr(d).add(a);b.className&&this.graphic.addClass(b.className);this.tracker=this.annotation.chart.renderer.path([["M",0,0]]).addClass("highcharts-tracker-line").attr({zIndex:2}).add(a);this.annotation.chart.styledMode||this.tracker.attr({"stroke-linejoin":"round",
stroke:F,fill:F,"stroke-width":this.graphic.strokeWidth()+2*b.snap});e.prototype.render.call(this);C(this.graphic,{markerStartSetter:t,markerEndSetter:h});this.setMarkers(this)};c.prototype.redraw=function(a){if(this.graphic){var b=this.toD(),d=a?"animate":"attr";b?(this.graphic[d]({d:b}),this.tracker[d]({d:b})):(this.graphic.attr({d:"M 0 -9000000000"}),this.tracker.attr({d:"M 0 -9000000000"}));this.graphic.placed=this.tracker.placed=!!b}e.prototype.redraw.call(this,a)};c.prototype.setMarkers=function(a){var b=
a.options,d=a.chart,e=d.options.defs,f=b.fill,c=g(f)&&"none"!==f?f:b.stroke;["markerStart","markerEnd"].forEach(function(f){var h=b[f],g;if(h){for(g in e){var n=e[g];if((h===(n.attributes&&n.attributes.id)||h===n.id)&&"marker"===n.tagName){var t=n;break}}t&&(h=a[f]=d.renderer.addMarker((b.id||A())+"-"+h,D(t,{color:c})),a.attr(f,h.getAttribute("id")))}})};c.attrsMap={dashStyle:"dashstyle",strokeWidth:"stroke-width",stroke:"stroke",fill:"fill",zIndex:"zIndex"};return c}(c)});r(c,"Extensions/Annotations/Controllables/ControllableRect.js",
[c["Extensions/Annotations/Controllables/Controllable.js"],c["Extensions/Annotations/Controllables/ControllablePath.js"],c["Core/Utilities.js"]],function(c,l,w){var m=this&&this.__extends||function(){var f=function(a,b){f=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(a,b){a.__proto__=b}||function(a,b){for(var d in b)b.hasOwnProperty(d)&&(a[d]=b[d])};return f(a,b)};return function(a,b){function e(){this.constructor=a}f(a,b);a.prototype=null===b?Object.create(b):(e.prototype=b.prototype,
new e)}}(),k=w.merge;return function(f){function a(a,e,d){a=f.call(this,a,e,d,"shape")||this;a.type="rect";a.translate=f.prototype.translateShape;return a}m(a,f);a.prototype.render=function(a){var b=this.attrsFromOptions(this.options);this.graphic=this.annotation.chart.renderer.rect(0,-9E9,0,0).attr(b).add(a);f.prototype.render.call(this)};a.prototype.redraw=function(a){if(this.graphic){var b=this.anchor(this.points[0]).absolutePosition;if(b)this.graphic[a?"animate":"attr"]({x:b.x,y:b.y,width:this.options.width,
height:this.options.height});else this.attr({x:0,y:-9E9});this.graphic.placed=!!b}f.prototype.redraw.call(this,a)};a.attrsMap=k(l.attrsMap,{width:"width",height:"height"});return a}(c)});r(c,"Extensions/Annotations/Controllables/ControllableCircle.js",[c["Extensions/Annotations/Controllables/Controllable.js"],c["Extensions/Annotations/Controllables/ControllablePath.js"],c["Core/Utilities.js"]],function(c,l,w){var m=this&&this.__extends||function(){var f=function(a,b){f=Object.setPrototypeOf||{__proto__:[]}instanceof
Array&&function(a,b){a.__proto__=b}||function(a,b){for(var d in b)b.hasOwnProperty(d)&&(a[d]=b[d])};return f(a,b)};return function(a,b){function e(){this.constructor=a}f(a,b);a.prototype=null===b?Object.create(b):(e.prototype=b.prototype,new e)}}(),k=w.merge;return function(f){function a(a,e,d){a=f.call(this,a,e,d,"shape")||this;a.type="circle";a.translate=f.prototype.translateShape;return a}m(a,f);a.prototype.redraw=function(a){if(this.graphic){var b=this.anchor(this.points[0]).absolutePosition;
if(b)this.graphic[a?"animate":"attr"]({x:b.x,y:b.y,r:this.options.r});else this.graphic.attr({x:0,y:-9E9});this.graphic.placed=!!b}f.prototype.redraw.call(this,a)};a.prototype.render=function(a){var b=this.attrsFromOptions(this.options);this.graphic=this.annotation.chart.renderer.circle(0,-9E9,0).attr(b).add(a);f.prototype.render.call(this)};a.prototype.setRadius=function(a){this.options.r=a};a.attrsMap=k(l.attrsMap,{r:"r"});return a}(c)});r(c,"Extensions/Annotations/Controllables/ControllableEllipse.js",
[c["Extensions/Annotations/Controllables/Controllable.js"],c["Extensions/Annotations/Controllables/ControllablePath.js"],c["Core/Utilities.js"]],function(c,l,w){var m=this&&this.__extends||function(){var a=function(b,e){a=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(a,b){a.__proto__=b}||function(a,b){for(var d in b)b.hasOwnProperty(d)&&(a[d]=b[d])};return a(b,e)};return function(b,e){function d(){this.constructor=b}a(b,e);b.prototype=null===e?Object.create(e):(d.prototype=e.prototype,
new d)}}(),k=w.merge,f=w.defined;return function(a){function b(b,d,f){b=a.call(this,b,d,f,"shape")||this;b.type="ellipse";return b}m(b,a);b.prototype.init=function(b,d,c){f(d.yAxis)&&d.points.forEach(function(a){a.yAxis=d.yAxis});f(d.xAxis)&&d.points.forEach(function(a){a.xAxis=d.xAxis});a.prototype.init.call(this,b,d,c)};b.prototype.render=function(b){this.graphic=this.annotation.chart.renderer.createElement("ellipse").attr(this.attrsFromOptions(this.options)).add(b);a.prototype.render.call(this)};
b.prototype.translate=function(b,d){a.prototype.translateShape.call(this,b,d,!0)};b.prototype.getDistanceFromLine=function(a,b,f,c){return Math.abs((b.y-a.y)*f-(b.x-a.x)*c+b.x*a.y-b.y*a.x)/Math.sqrt((b.y-a.y)*(b.y-a.y)+(b.x-a.x)*(b.x-a.x))};b.prototype.getAttrs=function(a,b){var d=a.x,e=a.y,f=b.x,c=b.y;b=(d+f)/2;a=(e+c)/2;var q=Math.sqrt((d-f)*(d-f)/4+(e-c)*(e-c)/4);e=180*Math.atan((c-e)/(f-d))/Math.PI;b<d&&(e+=180);d=this.getRY();return{cx:b,cy:a,rx:q,ry:d,angle:e}};b.prototype.getRY=function(){var a=
this.getYAxis();return f(a)?Math.abs(a.toPixels(this.options.ry)-a.toPixels(0)):this.options.ry};b.prototype.getYAxis=function(){return this.chart.yAxis[this.options.yAxis]};b.prototype.getAbsolutePosition=function(a){return this.anchor(a).absolutePosition};b.prototype.redraw=function(b){if(this.graphic){var d=this.getAbsolutePosition(this.points[0]),e=this.getAbsolutePosition(this.points[1]);e=this.getAttrs(d,e);if(d)this.graphic[b?"animate":"attr"]({cx:e.cx,cy:e.cy,rx:e.rx,ry:e.ry,rotation:e.angle,
rotationOriginX:e.cx,rotationOriginY:e.cy});else this.graphic.attr({x:0,y:-9E9});this.graphic.placed=!!d}a.prototype.redraw.call(this,b)};b.prototype.setYRadius=function(a){var b=this.annotation.userOptions.shapes;this.options.ry=a;b&&b[0]&&(b[0].ry=a,b[0].ry=a)};b.attrsMap=k(l.attrsMap,{ry:"ry"});return b}(c)});r(c,"Extensions/Annotations/Controllables/ControllableLabel.js",[c["Extensions/Annotations/Controllables/Controllable.js"],c["Core/FormatUtilities.js"],c["Extensions/Annotations/MockPoint.js"],
c["Core/Tooltip.js"],c["Core/Utilities.js"]],function(c,l,w,m,k){function f(a,b,e,f,c){var h=c&&c.anchorX;c=c&&c.anchorY;var t=e/2;if(d(h)&&d(c)){var q=[["M",h,c]];var g=b-c;0>g&&(g=-f-g);g<e&&(t=h<a+e/2?g:e-g);c>b+f?q.push(["L",a+t,b+f]):c<b?q.push(["L",a+t,b]):h<a?q.push(["L",a,b+f/2]):h>a+e&&q.push(["L",a+e,b+f/2])}return q||[]}var a=this&&this.__extends||function(){var a=function(b,d){a=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(a,b){a.__proto__=b}||function(a,b){for(var d in b)b.hasOwnProperty(d)&&
(a[d]=b[d])};return a(b,d)};return function(b,d){function e(){this.constructor=b}a(b,d);b.prototype=null===d?Object.create(d):(e.prototype=d.prototype,new e)}}(),b=l.format,e=k.extend,d=k.isNumber,g=k.pick,p=[];return function(d){function c(a,b,e){return d.call(this,a,b,e,"label")||this}a(c,d);c.alignedPosition=function(a,b){var d=a.align,e=a.verticalAlign,f=(b.x||0)+(a.x||0),c=(b.y||0)+(a.y||0),h,g;"right"===d?h=1:"center"===d&&(h=2);h&&(f+=(b.width-(a.width||0))/h);"bottom"===e?g=1:"middle"===e&&
(g=2);g&&(c+=(b.height-(a.height||0))/g);return{x:Math.round(f),y:Math.round(c)}};c.compose=function(a){-1===p.indexOf(a)&&(p.push(a),a.prototype.symbols.connector=f)};c.justifiedOptions=function(a,b,d,e){var f=d.align,c=d.verticalAlign,h=b.box?0:b.padding||0,g=b.getBBox();b={align:f,verticalAlign:c,x:d.x,y:d.y,width:b.width,height:b.height};d=(e.x||0)-a.plotLeft;e=(e.y||0)-a.plotTop;var t=d+h;0>t&&("right"===f?b.align="left":b.x=(b.x||0)-t);t=d+g.width-h;t>a.plotWidth&&("left"===f?b.align="right":
b.x=(b.x||0)+a.plotWidth-t);t=e+h;0>t&&("bottom"===c?b.verticalAlign="top":b.y=(b.y||0)-t);t=e+g.height-h;t>a.plotHeight&&("top"===c?b.verticalAlign="bottom":b.y=(b.y||0)+a.plotHeight-t);return b};c.prototype.translatePoint=function(a,b){d.prototype.translatePoint.call(this,a,b,0)};c.prototype.translate=function(a,b){var d=this.annotation.chart,e=this.annotation.userOptions,f=d.annotations.indexOf(this.annotation);f=d.options.annotations[f];d.inverted&&(d=a,a=b,b=d);this.options.x+=a;this.options.y+=
b;f[this.collection][this.index].x=this.options.x;f[this.collection][this.index].y=this.options.y;e[this.collection][this.index].x=this.options.x;e[this.collection][this.index].y=this.options.y};c.prototype.render=function(a){var b=this.options,e=this.attrsFromOptions(b),f=b.style;this.graphic=this.annotation.chart.renderer.label("",0,-9999,b.shape,null,null,b.useHTML,null,"annotation-label").attr(e).add(a);this.annotation.chart.styledMode||("contrast"===f.color&&(f.color=this.annotation.chart.renderer.getContrast(-1<
c.shapesWithoutBackground.indexOf(b.shape)?"#FFFFFF":b.backgroundColor)),this.graphic.css(b.style).shadow(b.shadow));b.className&&this.graphic.addClass(b.className);this.graphic.labelrank=b.labelrank;d.prototype.render.call(this)};c.prototype.redraw=function(a){var e=this.options,f=this.text||e.format||e.text,c=this.graphic,g=this.points[0];c?(c.attr({text:f?b(String(f),g.getLabelConfig(),this.annotation.chart):e.formatter.call(g,this)}),e=this.anchor(g),(f=this.position(e))?(c.alignAttr=f,f.anchorX=
e.absolutePosition.x,f.anchorY=e.absolutePosition.y,c[a?"animate":"attr"](f)):c.attr({x:0,y:-9999}),c.placed=!!f,d.prototype.redraw.call(this,a)):this.redraw(a)};c.prototype.anchor=function(a){var b=d.prototype.anchor.apply(this,arguments),e=this.options.x||0,f=this.options.y||0;b.absolutePosition.x-=e;b.absolutePosition.y-=f;b.relativePosition.x-=e;b.relativePosition.y-=f;return b};c.prototype.position=function(a){var b=this.graphic,d=this.annotation.chart,f=this.points[0],k=this.options,l=a.absolutePosition,
q=a.relativePosition,p=f.series.visible&&w.prototype.isInsidePlot.call(f);if(b&&p){var u=b.width;a=void 0===u?0:u;u=b.height;var C=void 0===u?0:u;k.distance?u=m.prototype.getPosition.call({chart:d,distance:g(k.distance,16)},a,C,{plotX:q.x,plotY:q.y,negative:f.negative,ttBelow:f.ttBelow,h:q.height||q.width}):k.positioner?u=k.positioner.call(this):(f={x:l.x,y:l.y,width:0,height:0},u=c.alignedPosition(e(k,{width:a,height:C}),f),"justify"===this.options.overflow&&(u=c.alignedPosition(c.justifiedOptions(d,
b,k,u),f)));k.crop&&(b=u.x-d.plotLeft,k=u.y-d.plotTop,p=d.isInsidePlot(b,k)&&d.isInsidePlot(b+a,k+C))}return p?u:null};c.attrsMap={backgroundColor:"fill",borderColor:"stroke",borderWidth:"stroke-width",zIndex:"zIndex",borderRadius:"r",padding:"padding"};c.shapesWithoutBackground=["connector"];return c}(c)});r(c,"Extensions/Annotations/Controllables/ControllableImage.js",[c["Extensions/Annotations/Controllables/Controllable.js"],c["Extensions/Annotations/Controllables/ControllableLabel.js"]],function(c,
l){var p=this&&this.__extends||function(){var c=function(k,f){c=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(a,b){a.__proto__=b}||function(a,b){for(var e in b)b.hasOwnProperty(e)&&(a[e]=b[e])};return c(k,f)};return function(k,f){function a(){this.constructor=k}c(k,f);k.prototype=null===f?Object.create(f):(a.prototype=f.prototype,new a)}}();return function(c){function k(f,a,b){f=c.call(this,f,a,b,"shape")||this;f.type="image";f.translate=c.prototype.translateShape;return f}p(k,c);
k.prototype.render=function(f){var a=this.attrsFromOptions(this.options),b=this.options;this.graphic=this.annotation.chart.renderer.image(b.src,0,-9E9,b.width,b.height).attr(a).add(f);this.graphic.width=b.width;this.graphic.height=b.height;c.prototype.render.call(this)};k.prototype.redraw=function(f){if(this.graphic){var a=this.anchor(this.points[0]);if(a=l.prototype.position.call(this,a))this.graphic[f?"animate":"attr"]({x:a.x,y:a.y});else this.graphic.attr({x:0,y:-9E9});this.graphic.placed=!!a}c.prototype.redraw.call(this,
f)};k.attrsMap={width:"width",height:"height",zIndex:"zIndex"};return k}(c)});r(c,"Core/Chart/ChartNavigationComposition.js",[],function(){var c;(function(c){c.compose=function(c){c.navigation||(c.navigation=new l(c));return c};var l=function(){function c(c){this.updates=[];this.chart=c}c.prototype.addUpdate=function(c){this.chart.navigation.updates.push(c)};c.prototype.update=function(c,f){var a=this;this.updates.forEach(function(b){b.call(a.chart,c,f)})};return c}();c.Additions=l})(c||(c={}));return c});
r(c,"Extensions/Annotations/NavigationBindingsUtilities.js",[c["Core/Utilities.js"]],function(c){var l=c.defined,p=c.isNumber,m=c.pick,k={backgroundColor:"string",borderColor:"string",borderRadius:"string",color:"string",fill:"string",fontSize:"string",labels:"string",name:"string",stroke:"string",title:"string"};return{annotationsFieldsTypes:k,getAssignedAxis:function(c){return c.filter(function(a){var b=a.axis.getExtremes(),c=b.min;b=b.max;var d=m(a.axis.minPointOffset,0);return p(c)&&p(b)&&a.value>=
c-d&&a.value<=b+d&&!a.axis.options.isInternal})[0]},getFieldType:function(c,a){c=k[c];a=typeof a;l(c)&&(a=c);return{string:"text",number:"number","boolean":"checkbox"}[a]}}});r(c,"Extensions/Annotations/NavigationBindingsDefaults.js",[c["Extensions/Annotations/NavigationBindingsUtilities.js"],c["Core/Utilities.js"]],function(c,l){var p=c.getAssignedAxis,m=l.isNumber,k=l.merge;return{lang:{navigation:{popup:{simpleShapes:"Simple shapes",lines:"Lines",circle:"Circle",ellipse:"Ellipse",rectangle:"Rectangle",
label:"Label",shapeOptions:"Shape options",typeOptions:"Details",fill:"Fill",format:"Text",strokeWidth:"Line width",stroke:"Line color",title:"Title",name:"Name",labelOptions:"Label options",labels:"Labels",backgroundColor:"Background color",backgroundColors:"Background colors",borderColor:"Border color",borderRadius:"Border radius",borderWidth:"Border width",style:"Style",padding:"Padding",fontSize:"Font size",color:"Color",height:"Height",shapes:"Shape options"}}},navigation:{bindingsClassName:"highcharts-bindings-container",
bindings:{circleAnnotation:{className:"highcharts-circle-annotation",start:function(c){var a=this.chart.pointer.getCoordinates(c);c=p(a.xAxis);a=p(a.yAxis);var b=this.chart.options.navigation;if(c&&a)return this.chart.addAnnotation(k({langKey:"circle",type:"basicAnnotation",shapes:[{type:"circle",point:{x:c.value,y:a.value,xAxis:c.axis.options.index,yAxis:a.axis.options.index},r:5}]},b.annotationsOptions,b.bindings.circleAnnotation.annotationsOptions))},steps:[function(c,a){var b=a.options.shapes;
b=b&&b[0]&&b[0].point||{};if(m(b.xAxis)&&m(b.yAxis)){var e=this.chart.inverted;var d=this.chart.xAxis[b.xAxis].toPixels(b.x);b=this.chart.yAxis[b.yAxis].toPixels(b.y);e=Math.max(Math.sqrt(Math.pow(e?b-c.chartX:d-c.chartX,2)+Math.pow(e?d-c.chartY:b-c.chartY,2)),5)}a.update({shapes:[{r:e}]})}]},ellipseAnnotation:{className:"highcharts-ellipse-annotation",start:function(c){var a=this.chart.pointer.getCoordinates(c);c=p(a.xAxis);a=p(a.yAxis);var b=this.chart.options.navigation;if(c&&a)return this.chart.addAnnotation(k({langKey:"ellipse",
type:"basicAnnotation",shapes:[{type:"ellipse",xAxis:c.axis.options.index,yAxis:a.axis.options.index,points:[{x:c.value,y:a.value},{x:c.value,y:a.value}],ry:1}]},b.annotationsOptions,b.bindings.ellipseAnnotation.annotationOptions))},steps:[function(c,a){a=a.shapes[0];var b=a.getAbsolutePosition(a.points[1]);a.translatePoint(c.chartX-b.x,c.chartY-b.y,1);a.redraw(!1)},function(c,a){a=a.shapes[0];var b=a.getAbsolutePosition(a.points[0]),e=a.getAbsolutePosition(a.points[1]);c=a.getDistanceFromLine(b,
e,c.chartX,c.chartY);b=a.getYAxis();c=Math.abs(b.toValue(0)-b.toValue(c));a.setYRadius(c);a.redraw(!1)}]},rectangleAnnotation:{className:"highcharts-rectangle-annotation",start:function(c){c=this.chart.pointer.getCoordinates(c);var a=p(c.xAxis),b=p(c.yAxis);if(a&&b){c=a.value;var e=b.value;a=a.axis.options.index;b=b.axis.options.index;var d=this.chart.options.navigation;return this.chart.addAnnotation(k({langKey:"rectangle",type:"basicAnnotation",shapes:[{type:"path",points:[{xAxis:a,yAxis:b,x:c,
y:e},{xAxis:a,yAxis:b,x:c,y:e},{xAxis:a,yAxis:b,x:c,y:e},{xAxis:a,yAxis:b,x:c,y:e},{command:"Z"}]}]},d.annotationsOptions,d.bindings.rectangleAnnotation.annotationsOptions))}},steps:[function(c,a){var b=a.options.shapes;b=b&&b[0]&&b[0].points||[];var e=this.chart.pointer.getCoordinates(c);c=p(e.xAxis);e=p(e.yAxis);c&&e&&(c=c.value,e=e.value,b[1].x=c,b[2].x=c,b[2].y=e,b[3].y=e,a.update({shapes:[{points:b}]}))}]},labelAnnotation:{className:"highcharts-label-annotation",start:function(c){var a=this.chart.pointer.getCoordinates(c);
c=p(a.xAxis);a=p(a.yAxis);var b=this.chart.options.navigation;if(c&&a)return this.chart.addAnnotation(k({langKey:"label",type:"basicAnnotation",labelOptions:{format:"{y:.2f}"},labels:[{point:{xAxis:c.axis.options.index,yAxis:a.axis.options.index,x:c.value,y:a.value},overflow:"none",crop:!0}]},b.annotationsOptions,b.bindings.labelAnnotation.annotationsOptions))}}},events:{},annotationsOptions:{animation:{defer:0}}}}});r(c,"Extensions/Annotations/NavigationBindings.js",[c["Core/Chart/ChartNavigationComposition.js"],
c["Core/Defaults.js"],c["Core/FormatUtilities.js"],c["Core/Globals.js"],c["Extensions/Annotations/NavigationBindingsDefaults.js"],c["Extensions/Annotations/NavigationBindingsUtilities.js"],c["Core/Utilities.js"]],function(c,l,w,m,k,f,a){function b(a,b){var c=z.Element.prototype,d=c.matches||c.msMatchesSelector||c.webkitMatchesSelector,e=null;if(c.closest)e=c.closest.call(a,b);else{do{if(d.call(a,b))return a;a=a.parentElement||a.parentNode}while(null!==a&&1===a.nodeType)}return e}function e(){this.chart.navigationBindings&&
this.chart.navigationBindings.deselectAnnotation()}function d(){this.navigationBindings&&this.navigationBindings.destroy()}function g(){var a=this.options;a&&a.navigation&&a.navigation.bindings&&(this.navigationBindings=new L(this,a.navigation),this.navigationBindings.initEvents(),this.navigationBindings.initUpdate())}function p(){var a=this.navigationBindings;if(this&&a){var b=!1;this.series.forEach(function(a){!a.options.isInternal&&a.visible&&(b=!0)});if(this.navigationBindings&&this.navigationBindings.container&&
this.navigationBindings.container[0]){var c=this.navigationBindings.container[0];x(a.boundClassNames,function(a,d){if(d=c.querySelectorAll("."+d))for(var e=0;e<d.length;e++){var f=d[e],n=f.className;"normal"===a.noDataState?-1!==n.indexOf("highcharts-disabled-btn")&&f.classList.remove("highcharts-disabled-btn"):b?-1!==n.indexOf("highcharts-disabled-btn")&&f.classList.remove("highcharts-disabled-btn"):-1===n.indexOf("highcharts-disabled-btn")&&(f.className+=" highcharts-disabled-btn")}})}}}function D(){this.deselectAnnotation()}
function A(){this.selectedButtonElement=null}function q(a){var b=a.prototype.defaultOptions.events&&a.prototype.defaultOptions.events.click;E(!0,a.prototype.defaultOptions.events,{click:function(a){var c=this,d=c.chart.navigationBindings,e=d.activeAnnotation;b&&b.call(c,a);e!==c?(d.deselectAnnotation(),d.activeAnnotation=c,c.setControlPointsVisibility(!0),u(d,"showPopup",{annotation:c,formType:"annotation-toolbar",options:d.annotationToFields(c),onSubmit:function(a){if("remove"===a.actionType)d.activeAnnotation=
!1,d.chart.removeAnnotation(c);else{var b={};d.fieldsToOptions(a.fields,b);d.deselectAnnotation();a=b.typeOptions;"measure"===c.options.type&&(a.crosshairY.enabled=0!==a.crosshairY.strokeWidth,a.crosshairX.enabled=0!==a.crosshairX.strokeWidth);c.update(b)}}})):u(d,"closePopup");a.activeAnnotation=!0}})}var h=l.setOptions,t=w.format,F=m.doc,z=m.win,G=f.getFieldType,y=a.addEvent,r=a.attr,u=a.fireEvent,H=a.isArray,B=a.isFunction,I=a.isNumber,J=a.isObject,E=a.merge,x=a.objectEach,n=a.pick,v=[],L=function(){function a(a,
b){this.selectedButton=this.boundClassNames=void 0;this.chart=a;this.options=b;this.eventsToUnbind=[];this.container=this.chart.container.getElementsByClassName(this.options.bindingsClassName||"");this.container.length||(this.container=F.getElementsByClassName(this.options.bindingsClassName||""))}a.compose=function(b,c){-1===v.indexOf(b)&&(v.push(b),y(b,"remove",e),q(b),x(b.types,function(a){q(a)}));-1===v.indexOf(c)&&(v.push(c),y(c,"destroy",d),y(c,"load",g),y(c,"render",p));-1===v.indexOf(a)&&(v.push(a),
y(a,"closePopup",D),y(a,"deselectButton",A));-1===v.indexOf(h)&&(v.push(h),h(k))};a.prototype.initEvents=function(){var a=this,b=a.chart,c=a.container,d=a.options;a.boundClassNames={};x(d.bindings||{},function(b){a.boundClassNames[b.className]=b});[].forEach.call(c,function(b){a.eventsToUnbind.push(y(b,"click",function(c){var d=a.getButtonEvents(b,c);d&&-1===d.button.className.indexOf("highcharts-disabled-btn")&&a.bindingsButtonClick(d.button,d.events,c)}))});x(d.events||{},function(b,c){B(b)&&a.eventsToUnbind.push(y(a,
c,b,{passive:!1}))});a.eventsToUnbind.push(y(b.container,"click",function(c){!b.cancelClick&&b.isInsidePlot(c.chartX-b.plotLeft,c.chartY-b.plotTop,{visiblePlotOnly:!0})&&a.bindingsChartClick(this,c)}));a.eventsToUnbind.push(y(b.container,m.isTouchDevice?"touchmove":"mousemove",function(b){a.bindingsContainerMouseMove(this,b)},m.isTouchDevice?{passive:!1}:void 0))};a.prototype.initUpdate=function(){var a=this;c.compose(this.chart).navigation.addUpdate(function(b){a.update(b)})};a.prototype.bindingsButtonClick=
function(a,b,c){var d=this.chart,e=d.renderer.boxWrapper,f=!0;this.selectedButtonElement&&(this.selectedButtonElement.classList===a.classList&&(f=!1),u(this,"deselectButton",{button:this.selectedButtonElement}),this.nextEvent&&(this.currentUserDetails&&"annotations"===this.currentUserDetails.coll&&d.removeAnnotation(this.currentUserDetails),this.mouseMoveEvent=this.nextEvent=!1));f?(this.selectedButton=b,this.selectedButtonElement=a,u(this,"selectButton",{button:a}),b.init&&b.init.call(this,a,c),
(b.start||b.steps)&&d.renderer.boxWrapper.addClass("highcharts-draw-mode")):(d.stockTools&&d.stockTools.toggleButtonActiveClass(a),e.removeClass("highcharts-draw-mode"),this.mouseMoveEvent=this.nextEvent=!1,this.selectedButton=null)};a.prototype.bindingsChartClick=function(a,c){a=this.chart;var d=this.activeAnnotation,e=this.selectedButton;a=a.renderer.boxWrapper;d&&(d.cancelClick||c.activeAnnotation||!c.target.parentNode||b(c.target,".highcharts-popup")?d.cancelClick&&setTimeout(function(){d.cancelClick=
!1},0):u(this,"closePopup"));e&&e.start&&(this.nextEvent?(this.nextEvent(c,this.currentUserDetails),this.steps&&(this.stepIndex++,e.steps[this.stepIndex]?this.mouseMoveEvent=this.nextEvent=e.steps[this.stepIndex]:(u(this,"deselectButton",{button:this.selectedButtonElement}),a.removeClass("highcharts-draw-mode"),e.end&&e.end.call(this,c,this.currentUserDetails),this.mouseMoveEvent=this.nextEvent=!1,this.selectedButton=null))):(this.currentUserDetails=e.start.call(this,c))&&e.steps?(this.stepIndex=
0,this.steps=!0,this.mouseMoveEvent=this.nextEvent=e.steps[this.stepIndex]):(u(this,"deselectButton",{button:this.selectedButtonElement}),a.removeClass("highcharts-draw-mode"),this.steps=!1,this.selectedButton=null,e.end&&e.end.call(this,c,this.currentUserDetails)))};a.prototype.bindingsContainerMouseMove=function(a,b){this.mouseMoveEvent&&this.mouseMoveEvent(b,this.currentUserDetails)};a.prototype.fieldsToOptions=function(a,b){x(a,function(a,c){var d=parseFloat(a),e=c.split("."),f=e.length-1;!I(d)||
a.match(/px/g)||c.match(/format/g)||(a=d);if("undefined"!==a){var h=b;e.forEach(function(b,c){var d=n(e[c+1],"");f===c?h[b]=a:(h[b]||(h[b]=d.match(/\d/g)?[]:{}),h=h[b])})}});return b};a.prototype.deselectAnnotation=function(){this.activeAnnotation&&(this.activeAnnotation.setControlPointsVisibility(!1),this.activeAnnotation=!1)};a.prototype.annotationToFields=function(b){function c(a,d,e,n,h){if(e&&a&&-1===g.indexOf(d)&&(0<=(e.indexOf&&e.indexOf(d))||e[d]||!0===e))if(H(a))n[d]=[],a.forEach(function(a,
b){J(a)?(n[d][b]={},x(a,function(a,e){c(a,e,f[d],n[d][b],d)})):c(a,0,f[d],n[d],d)});else if(J(a)){var v={};H(n)?(n.push(v),v[d]={},v=v[d]):n[d]=v;x(a,function(a,b){c(a,b,0===d?e:f[d],v,d)})}else"format"===d?n[d]=[t(a,b.labels[0].points[0]).toString(),"text"]:H(n)?n.push([a,G(h,a)]):n[d]=[a,G(d,a)]}var d=b.options,e=a.annotationsEditable,f=e.nestedOptions,h=n(d.type,d.shapes&&d.shapes[0]&&d.shapes[0].type,d.labels&&d.labels[0]&&d.labels[0].type,"label"),g=a.annotationsNonEditable[d.langKey]||[],v=
{langKey:d.langKey,type:h};x(d,function(a,b){"typeOptions"===b?(v[b]={},x(d[b],function(a,d){c(a,d,f,v[b],d)})):c(a,b,e[h],v,b)});return v};a.prototype.getClickedClassNames=function(a,b){var d=b.target;b=[];for(var c;d&&((c=r(d,"class"))&&(b=b.concat(c.split(" ").map(function(a){return[a,d]}))),d=d.parentNode,d!==a););return b};a.prototype.getButtonEvents=function(a,b){var d=this,c;this.getClickedClassNames(a,b).forEach(function(a){d.boundClassNames[a[0]]&&!c&&(c={events:d.boundClassNames[a[0]],button:a[1]})});
return c};a.prototype.update=function(a){this.options=E(!0,this.options,a);this.removeEvents();this.initEvents()};a.prototype.removeEvents=function(){this.eventsToUnbind.forEach(function(a){return a()})};a.prototype.destroy=function(){this.removeEvents()};a.annotationsEditable={nestedOptions:{labelOptions:["style","format","backgroundColor"],labels:["style"],label:["style"],style:["fontSize","color"],background:["fill","strokeWidth","stroke"],innerBackground:["fill","strokeWidth","stroke"],outerBackground:["fill",
"strokeWidth","stroke"],shapeOptions:["fill","strokeWidth","stroke"],shapes:["fill","strokeWidth","stroke"],line:["strokeWidth","stroke"],backgroundColors:[!0],connector:["fill","strokeWidth","stroke"],crosshairX:["strokeWidth","stroke"],crosshairY:["strokeWidth","stroke"]},circle:["shapes"],ellipse:["shapes"],verticalLine:[],label:["labelOptions"],measure:["background","crosshairY","crosshairX"],fibonacci:[],tunnel:["background","line","height"],pitchfork:["innerBackground","outerBackground"],rect:["shapes"],
crookedLine:[],basicAnnotation:["shapes","labelOptions"]};a.annotationsNonEditable={rectangle:["crosshairX","crosshairY","labelOptions"],ellipse:["labelOptions"],circle:["labelOptions"]};return a}();"";return L});r(c,"Extensions/Annotations/Popup/PopupAnnotations.js",[c["Core/Globals.js"],c["Core/Utilities.js"]],function(c,l){function p(d,c,l,q,h,t){var F=this;if(c){var z=this.addInput,G=this.lang,y,C;e(q,function(e,f){y=""!==l?l+"."+f:f;b(e)&&(!a(e)||a(e)&&b(e[0])?(C=G[f]||f,C.match(/\d/g)||h.push([!0,
C,d]),p.call(F,d,c,y,e,h,!1)):h.push([F,y,"annotation",d,e]))});t&&(g(h,function(a){return a[1].match(/format/g)?-1:1}),k&&h.reverse(),h.forEach(function(a){!0===a[0]?f("span",{className:"highcharts-annotation-title"},void 0,a[2]).appendChild(m.createTextNode(a[1])):(a[4]={value:a[4][0],type:a[4][1]},z.apply(a[0],a.splice(1)))}))}}var m=c.doc,k=c.isFirefox,f=l.createElement,a=l.isArray,b=l.isObject,e=l.objectEach,d=l.pick,g=l.stableSort;return{addForm:function(a,b,d,c){if(a){var e=this.container,
g=this.lang,k=f("h2",{className:"highcharts-popup-main-title"},void 0,e);k.appendChild(m.createTextNode(g[b.langKey]||b.langKey||""));k=f("div",{className:"highcharts-popup-lhs-col highcharts-popup-lhs-full"},void 0,e);var l=f("div",{className:"highcharts-popup-bottom-row"},void 0,e);p.call(this,k,a,"",b,[],!0);this.addButton(l,c?g.addButton||"Add":g.saveButton||"Save",c?"add":"save",e,d)}},addToolbar:function(a,b,c){var e=this,g=this.lang,k=this.container,l=this.showForm;-1===k.className.indexOf("highcharts-annotation-toolbar")&&
(k.className+=" highcharts-annotation-toolbar");a&&(k.style.top=a.plotTop+10+"px");f("span",void 0,void 0,k).appendChild(m.createTextNode(d(g[b.langKey]||b.langKey,b.shapes&&b.shapes[0].type,"")));var p=this.addButton(k,g.removeButton||"Remove","remove",k,c);p.className+=" highcharts-annotation-remove-button";p.style["background-image"]="url("+this.iconsURL+"destroy.svg)";p=this.addButton(k,g.editButton||"Edit","edit",k,function(){l.call(e,"annotation-edit",a,b,c)});p.className+=" highcharts-annotation-edit-button";
p.style["background-image"]="url("+this.iconsURL+"edit.svg)"}}});r(c,"Extensions/Annotations/Popup/PopupIndicators.js",[c["Core/Renderer/HTML/AST.js"],c["Core/Globals.js"],c["Extensions/Annotations/NavigationBindingsUtilities.js"],c["Core/Series/SeriesRegistry.js"],c["Core/Utilities.js"]],function(c,l,r,m,k){function f(a){var b=z("div",{className:"highcharts-popup-lhs-col"},void 0,a);a=z("div",{className:"highcharts-popup-rhs-col"},void 0,a);z("div",{className:"highcharts-popup-rhs-col-wrapper"},
void 0,a);return{lhsCol:b,rhsCol:a}}function a(a,d,e,f){var n=this,g=n.lang,x=d.querySelectorAll(".highcharts-popup-lhs-col")[0];d=d.querySelectorAll(".highcharts-popup-rhs-col")[0];var k="edit"===e;e=k?a.series:a.options.plotOptions||{};if(a||!e){var l,m=[];k||y(e)?y(e)&&(m=w.call(this,e)):m=p.call(this,e,f);H(m,function(a,b){a=a.indicatorFullName.toLowerCase();b=b.indicatorFullName.toLowerCase();return a<b?-1:a>b?1:0});x.children[1]&&x.children[1].remove();var t=z("ul",{className:"highcharts-indicator-list"},
void 0,x),E=d.querySelectorAll(".highcharts-popup-rhs-col-wrapper")[0];m.forEach(function(d){var e=d.indicatorFullName,f=d.indicatorType,g=d.series;l=z("li",{className:"highcharts-indicator-list"},void 0,t);l.appendChild(h.createTextNode(e));["click","touchstart"].forEach(function(d){F(l,d,function(){var d=E.parentNode.children[1],e=g.params||g.options.params;E.innerHTML=c.emptyHTML;z("h3",{className:"highcharts-indicator-title"},void 0,E).appendChild(h.createTextNode(A(g,f).indicatorFullName));z("input",
{type:"hidden",name:"highcharts-type-"+f,value:f},void 0,E);q.call(n,f,"series",a,E,g,g.linkedParent&&g.linkedParent.options.id);e.volumeSeriesID&&q.call(n,f,"volume",a,E,g,g.linkedParent&&e.volumeSeriesID);b.call(n,a,"params",e,f,E);d&&(d.style.display="block");k&&g.options&&z("input",{type:"hidden",name:"highcharts-id-"+f,value:g.options.id},void 0,E).setAttribute("highcharts-data-series-id",g.options.id)})})});0<t.childNodes.length?t.childNodes[0].click():k||(c.setElementHTML(E.parentNode.children[0],
g.noFilterMatch||""),E.parentNode.children[1].style.display="none")}}function b(a,c,e,f,v){var n=this;if(a){var h=this.addInput;u(e,function(e,k){var x=c+"."+k;G(e)&&x&&(K(e)&&(h.call(n,x,f,v,{}),b.call(n,a,x,e,f,v)),x in B?(x=d.call(n,f,x,v),g.call(n,a,c,x,f,k,e)):"params.volumeSeriesID"===x||y(e)||h.call(n,x,f,v,{value:e,type:"number"}))})}}function e(b,d){var c=this,e=d.querySelectorAll(".highcharts-popup-lhs-col")[0];d=this.lang.clearFilter;e=z("div",{className:"highcharts-input-wrapper"},void 0,
e);var f=this.addInput("searchIndicators","input",e,{value:"",type:"text",htmlFor:"search-indicators",labelClassName:"highcharts-input-search-indicators-label"}),g=z("a",{textContent:d},void 0,e);f.classList.add("highcharts-input-search-indicators");g.classList.add("clear-filter-button");F(f,"input",function(d){a.call(c,b,c.container,"add",this.value);g.style.display=this.value.length?"inline-block":"none"});["click","touchstart"].forEach(function(d){F(g,d,function(){f.value="";a.call(c,b,c.container,
"add","");g.style.display="none"})})}function d(a,b,d){var c=b.split(".");c=c[c.length-1];a="highcharts-"+b+"-type-"+a;var e=this.lang;z("label",{htmlFor:a},null,d).appendChild(h.createTextNode(e[c]||b));d=z("select",{name:a,className:"highcharts-popup-field",id:"highcharts-select-"+b},null,d);d.setAttribute("id","highcharts-select-"+b);return d}function g(a,b,d,c,e,f,g){"series"===b||"volume"===b?a.series.forEach(function(a){var c=a.options,e=c.name||c.params?a.name:c.id||"";"highcharts-navigator-series"!==
c.id&&c.id!==(g&&g.options&&g.options.id)&&(G(f)||"volume"!==b||"column"!==a.type||(f=c.id),z("option",{value:c.id},void 0,d).appendChild(h.createTextNode(e)))}):c&&e&&I[e+"-"+c].forEach(function(a){z("option",{value:a},void 0,d).appendChild(h.createTextNode(a))});G(f)&&(d.value=f)}function p(a,b){var d=this.chart&&this.chart.options.lang,c=d&&d.navigation&&d.navigation.popup&&d.navigation.popup.indicatorAliases,e=[],f;u(a,function(a,d){var n=a&&a.options;if(a.params||n&&n.params)if(n=A(a,d),d=n.indicatorFullName,
n=n.indicatorType,b){var g=b.replace(/[.*+?^${}()|[\]\\]/g,"\\$&");g=new RegExp(g,"i");var h=c&&c[n]&&c[n].join(" ")||"";if(d.match(g)||h.match(g))f={indicatorFullName:d,indicatorType:n,series:a},e.push(f)}else f={indicatorFullName:d,indicatorType:n,series:a},e.push(f)});return e}function w(a){var b=[];a.forEach(function(a){a.is("sma")&&b.push({indicatorFullName:a.name,indicatorType:a.type,series:a})});return b}function A(a,b){var d=a.options,c=t[b]&&t[b].prototype.nameBase||b.toUpperCase();d&&d.type&&
(b=a.options.type,c=a.name);return{indicatorFullName:c,indicatorType:b}}function q(a,b,c,e,f,h){c&&(a=d.call(this,a,b,e),g.call(this,c,b,a,void 0,void 0,void 0,f),G(h)&&(a.value=h))}var h=l.doc,t=m.seriesTypes,F=k.addEvent,z=k.createElement,G=k.defined,y=k.isArray,K=k.isObject,u=k.objectEach,H=k.stableSort,B;(function(a){a[a["params.algorithm"]=0]="params.algorithm";a[a["params.average"]=1]="params.average"})(B||(B={}));var I={"algorithm-pivotpoints":["standard","fibonacci","camarilla"],"average-disparityindex":["sma",
"ema","dema","tema","wma"]};return{addForm:function(b,d,c){d=this.lang;if(b){this.tabs.init.call(this,b);var n=this.container.querySelectorAll(".highcharts-tab-item-content");f(n[0]);e.call(this,b,n[0]);a.call(this,b,n[0],"add");var g=n[0].querySelectorAll(".highcharts-popup-rhs-col")[0];this.addButton(g,d.addButton||"add","add",g,c);f(n[1]);a.call(this,b,n[1],"edit");g=n[1].querySelectorAll(".highcharts-popup-rhs-col")[0];this.addButton(g,d.saveButton||"save","edit",g,c);this.addButton(g,d.removeButton||
"remove","remove",g,c)}},getAmount:function(){var a=0;this.series.forEach(function(b){(b.params||b.options.params)&&a++});return a}}});r(c,"Extensions/Annotations/Popup/PopupTabs.js",[c["Core/Globals.js"],c["Core/Utilities.js"]],function(c,l){function p(){return e("div",{className:"highcharts-tab-item-content highcharts-no-mousewheel"},void 0,this.container)}function m(b,c){var d=this.container,f=this.lang,g="highcharts-tab-item";0===c&&(g+=" highcharts-tab-disabled");c=e("span",{className:g},void 0,
d);c.appendChild(a.createTextNode(f[b+"Button"]||b));c.setAttribute("highcharts-data-tab-type",b);return c}function k(a,b){var c=this.container.querySelectorAll(".highcharts-tab-item-content");a.className+=" highcharts-tab-item-active";c[b].className+=" highcharts-tab-item-show"}function f(a){var c=this;this.container.querySelectorAll(".highcharts-tab-item").forEach(function(d,e){0===a&&"edit"===d.getAttribute("highcharts-data-tab-type")||["click","touchstart"].forEach(function(a){b(d,a,function(){var a=
c.container,b=a.querySelectorAll(".highcharts-tab-item");a=a.querySelectorAll(".highcharts-tab-item-content");for(var d=0;d<b.length;d++)b[d].classList.remove("highcharts-tab-item-active"),a[d].classList.remove("highcharts-tab-item-show");k.call(c,this,e)})})})}var a=c.doc,b=l.addEvent,e=l.createElement;return{init:function(a){if(a){a=this.indicators.getAmount.call(a);var b=m.call(this,"add");m.call(this,"edit",a);p.call(this);p.call(this);f.call(this,a);k.call(this,b,0)}}}});r(c,"Extensions/Annotations/Popup/Popup.js",
[c["Core/Renderer/HTML/AST.js"],c["Core/Defaults.js"],c["Core/Globals.js"],c["Extensions/Annotations/Popup/PopupAnnotations.js"],c["Extensions/Annotations/Popup/PopupIndicators.js"],c["Extensions/Annotations/Popup/PopupTabs.js"],c["Core/Utilities.js"]],function(c,l,r,m,k,f,a){function b(a,b){var c=Array.prototype.slice.call(a.querySelectorAll("input")),d=Array.prototype.slice.call(a.querySelectorAll("select")),e=a.querySelectorAll("#highcharts-select-series > option:checked")[0];a=a.querySelectorAll("#highcharts-select-volume > option:checked")[0];
var f={actionType:b,linkedTo:e&&e.getAttribute("value")||"",fields:{}};c.forEach(function(a){var b=a.getAttribute("highcharts-data-name");a.getAttribute("highcharts-data-series-id")?f.seriesId=a.value:b?f.fields[b]=a.value:f.type=a.value});d.forEach(function(a){var b=a.id;"highcharts-select-series"!==b&&"highcharts-select-volume"!==b&&(b=b.split("highcharts-select-")[1],f.fields[b]=a.value)});a&&(f.fields["params.volumeSeriesID"]=a.getAttribute("value")||"");return f}var e=l.getOptions,d=r.doc,g=
a.addEvent,p=a.createElement;l=a.extend;var w=a.fireEvent,A=a.pick;a=function(){function a(a,b,c){this.chart=c;this.iconsURL=b;this.lang=e().lang.navigation.popup;this.container=p("div",{className:"highcharts-popup highcharts-no-tooltip"},void 0,a);g(this.container,"mousedown",function(){var a=c&&c.navigationBindings&&c.navigationBindings.activeAnnotation;if(a){a.cancelClick=!0;var b=g(r.doc,"click",function(){setTimeout(function(){a.cancelClick=!1},0);b()})}});this.addCloseBtn()}a.prototype.init=
function(b,c,d){a.call(this,b,c,d)};a.prototype.addCloseBtn=function(){var a=this,b=this.iconsURL,c=p("div",{className:"highcharts-popup-close"},void 0,this.container);c.style["background-image"]="url("+(b.match(/png|svg|jpeg|jpg|gif/ig)?b:b+"close.svg")+")";["click","touchstart"].forEach(function(b){g(c,b,function(){if(a.chart){var b=a.chart.navigationBindings;w(b,"closePopup");b&&b.selectedButtonElement&&w(b,"deselectButton",{button:b.selectedButtonElement})}else a.closePopup()})})};a.prototype.addInput=
function(a,b,c,e){var f=a.split(".");f=f[f.length-1];var g=this.lang;b="highcharts-"+b+"-"+A(e.htmlFor,f);f.match(/^\d+$/)||p("label",{htmlFor:b,className:e.labelClassName},void 0,c).appendChild(d.createTextNode(g[f]||f));c=p("input",{name:b,value:e.value,type:e.type,className:"highcharts-popup-field"},void 0,c);c.setAttribute("highcharts-data-name",a);return c};a.prototype.addButton=function(a,c,e,f,k){var h=this,l=p("button",void 0,void 0,a);l.appendChild(d.createTextNode(c));k&&["click","touchstart"].forEach(function(a){g(l,
a,function(){h.closePopup();return k(b(f,e))})});return l};a.prototype.showPopup=function(){var a=this.container,b=a.querySelectorAll(".highcharts-popup-close")[0];this.formType=void 0;a.innerHTML=c.emptyHTML;0<=a.className.indexOf("highcharts-annotation-toolbar")&&(a.classList.remove("highcharts-annotation-toolbar"),a.removeAttribute("style"));a.appendChild(b);a.style.display="block";a.style.height=""};a.prototype.closePopup=function(){this.container.style.display="none"};a.prototype.showForm=function(a,
b,c,d){b&&(this.showPopup(),"indicators"===a&&this.indicators.addForm.call(this,b,c,d),"annotation-toolbar"===a&&this.annotations.addToolbar.call(this,b,c,d),"annotation-edit"===a&&this.annotations.addForm.call(this,b,c,d),"flag"===a&&this.annotations.addForm.call(this,b,c,d,!0),this.formType=a,this.container.style.height=this.container.offsetHeight+"px")};return a}();l(a.prototype,{annotations:m,indicators:k,tabs:f});return a});r(c,"Extensions/Annotations/Popup/PopupComposition.js",[c["Extensions/Annotations/Popup/Popup.js"],
c["Core/Utilities.js"]],function(c,l){function p(){this.popup&&this.popup.closePopup()}function m(a){this.popup||(this.popup=new c(this.chart.container,this.chart.options.navigation.iconsURL||this.chart.options.stockTools&&this.chart.options.stockTools.gui.iconsURL||"https://code.highcharts.com/10.3.3/gfx/stock-icons/",this.chart));this.popup.showForm(a.formType,this.chart,a.options,a.onSubmit)}function k(a,b){this.inClass(b.target,"highcharts-popup")||a.apply(this,Array.prototype.slice.call(arguments,
1))}var f=l.addEvent,a=l.wrap,b=[];return{compose:function(c,d){-1===b.indexOf(c)&&(b.push(c),f(c,"closePopup",p),f(c,"showPopup",m));-1===b.indexOf(d)&&(b.push(d),a(d.prototype,"onContainerMouseDown",k))}}});r(c,"Extensions/Annotations/Annotation.js",[c["Core/Animation/AnimationUtilities.js"],c["Extensions/Annotations/AnnotationChart.js"],c["Extensions/Annotations/AnnotationDefaults.js"],c["Extensions/Annotations/Controllables/Controllable.js"],c["Extensions/Annotations/Controllables/ControllableRect.js"],
c["Extensions/Annotations/Controllables/ControllableCircle.js"],c["Extensions/Annotations/Controllables/ControllableEllipse.js"],c["Extensions/Annotations/Controllables/ControllablePath.js"],c["Extensions/Annotations/Controllables/ControllableImage.js"],c["Extensions/Annotations/Controllables/ControllableLabel.js"],c["Extensions/Annotations/ControlPoint.js"],c["Extensions/Annotations/EventEmitter.js"],c["Extensions/Annotations/MockPoint.js"],c["Extensions/Annotations/NavigationBindings.js"],c["Extensions/Annotations/Popup/PopupComposition.js"],
c["Core/Utilities.js"]],function(c,l,r,m,k,f,a,b,e,d,g,C,D,A,q,h){function p(a){var b=a.graphic;a=a.points.some(function(a){return!1!==a.series.visible&&!1!==a.visible});b&&(a?"hidden"===b.visibility&&b.show():b.hide())}function w(a,b){var c={};["labels","shapes"].forEach(function(d){var e=a[d];e&&(c[d]=b[d]?J(b[d]).map(function(a,b){return B(e[b],a)}):a[d])});return c}var z=this&&this.__extends||function(){var a=function(b,c){a=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(a,b){a.__proto__=
b}||function(a,b){for(var c in b)b.hasOwnProperty(c)&&(a[c]=b[c])};return a(b,c)};return function(b,c){function d(){this.constructor=b}a(b,c);b.prototype=null===c?Object.create(c):(d.prototype=c.prototype,new d)}}(),G=c.getDeferredAnimation,y=m.prototype,K=h.destroyObjectProperties,u=h.erase,H=h.fireEvent,B=h.merge,I=h.pick,J=h.splat;c=function(c){function h(a,b){var d=c.call(this)||this;d.annotation=void 0;d.coll="annotations";d.collection=void 0;d.animationConfig=void 0;d.graphic=void 0;d.group=
void 0;d.labelCollector=void 0;d.labelsGroup=void 0;d.shapesGroup=void 0;d.chart=a;d.points=[];d.controlPoints=[];d.coll="annotations";d.labels=[];d.shapes=[];d.options=B(d.defaultOptions,b);d.userOptions=b;b=w(d.options,b);d.options.labels=b.labels;d.options.shapes=b.shapes;d.init(a,d.options);return d}z(h,c);h.compose=function(a,c,e){l.compose(h,a,c);d.compose(e);b.compose(a,e);A.compose(h,a);q.compose(A,c)};h.prototype.addClipPaths=function(){this.setClipAxes();this.clipXAxis&&this.clipYAxis&&
this.options.crop&&(this.clipRect=this.chart.renderer.clipRect(this.getClipBox()))};h.prototype.addLabels=function(){var a=this,b=this.options.labels||[];b.forEach(function(c,d){c=a.initLabel(c,d);B(!0,b[d],c.options)})};h.prototype.addShapes=function(){var a=this,b=this.options.shapes||[];b.forEach(function(c,d){c=a.initShape(c,d);B(!0,b[d],c.options)})};h.prototype.destroy=function(){var a=this.chart,b=function(a){a.destroy()};this.labels.forEach(b);this.shapes.forEach(b);this.clipYAxis=this.clipXAxis=
null;u(a.labelCollectors,this.labelCollector);c.prototype.destroy.call(this);y.destroy.call(this);K(this,a)};h.prototype.destroyItem=function(a){u(this[a.itemType+"s"],a);a.destroy()};h.prototype.getClipBox=function(){if(this.clipXAxis&&this.clipYAxis)return{x:this.clipXAxis.left,y:this.clipYAxis.top,width:this.clipXAxis.width,height:this.clipYAxis.height}};h.prototype.init=function(a,b,c){a=this.chart;b=this.options.animation;this.linkPoints();this.addControlPoints();this.addShapes();this.addLabels();
this.setLabelCollector();this.animationConfig=G(a,b)};h.prototype.initLabel=function(a,b){a=B(this.options.labelOptions,{controlPointOptions:this.options.controlPointOptions},a);b=new d(this,a,b);b.itemType="label";this.labels.push(b);return b};h.prototype.initShape=function(a,b){a=B(this.options.shapeOptions,{controlPointOptions:this.options.controlPointOptions},a);b=new h.shapesMap[a.type](this,a,b);b.itemType="shape";this.shapes.push(b);return b};h.prototype.redraw=function(a){this.linkPoints();
this.graphic||this.render();this.clipRect&&this.clipRect.animate(this.getClipBox());this.redrawItems(this.shapes,a);this.redrawItems(this.labels,a);y.redraw.call(this,a)};h.prototype.redrawItem=function(a,b){a.linkPoints();a.shouldBeDrawn()?(a.graphic||this.renderItem(a),a.redraw(I(b,!0)&&a.graphic.placed),a.points.length&&p(a)):this.destroyItem(a)};h.prototype.redrawItems=function(a,b){for(var c=a.length;c--;)this.redrawItem(a[c],b)};h.prototype.remove=function(){return this.chart.removeAnnotation(this)};
h.prototype.render=function(){var a=this.chart.renderer;this.graphic=a.g("annotation").attr({opacity:0,zIndex:this.options.zIndex,visibility:this.options.visible?"inherit":"hidden"}).add();this.shapesGroup=a.g("annotation-shapes").add(this.graphic);this.options.crop&&this.shapesGroup.clip(this.chart.plotBoxClip);this.labelsGroup=a.g("annotation-labels").attr({translateX:0,translateY:0}).add(this.graphic);this.addClipPaths();this.clipRect&&this.graphic.clip(this.clipRect);this.renderItems(this.shapes);
this.renderItems(this.labels);this.addEvents();y.render.call(this)};h.prototype.renderItem=function(a){a.render("label"===a.itemType?this.labelsGroup:this.shapesGroup)};h.prototype.renderItems=function(a){for(var b=a.length;b--;)this.renderItem(a[b])};h.prototype.setClipAxes=function(){var a=this.chart.xAxis,b=this.chart.yAxis,c=(this.options.labels||[]).concat(this.options.shapes||[]).reduce(function(c,d){d=d&&(d.point||d.points&&d.points[0]);return[a[d&&d.xAxis]||c[0],b[d&&d.yAxis]||c[1]]},[]);
this.clipXAxis=c[0];this.clipYAxis=c[1]};h.prototype.setControlPointsVisibility=function(a){var b=function(b){b.setControlPointsVisibility(a)};y.setControlPointsVisibility.call(this,a);this.shapes.forEach(b);this.labels.forEach(b)};h.prototype.setLabelCollector=function(){var a=this;a.labelCollector=function(){return a.labels.reduce(function(a,b){b.options.allowOverlap||a.push(b.graphic);return a},[])};a.chart.labelCollectors.push(a.labelCollector)};h.prototype.setOptions=function(a){this.options=
B(this.defaultOptions,a)};h.prototype.setVisibility=function(a){var b=this.options,c=this.chart.navigationBindings;a=I(a,!b.visible);this.graphic.attr("visibility",a?"inherit":"hidden");a||(this.setControlPointsVisibility(!1),c.activeAnnotation===this&&c.popup&&"annotation-toolbar"===c.popup.formType&&H(c,"closePopup"));b.visible=a};h.prototype.update=function(a,b){var c=this.chart,d=w(this.userOptions,a),e=c.annotations.indexOf(this);a=B(!0,this.userOptions,a);a.labels=d.labels;a.shapes=d.shapes;
this.destroy();this.constructor(c,a);c.options.annotations[e]=a;this.isUpdating=!0;I(b,!0)&&c.redraw();H(this,"afterUpdate");this.isUpdating=!1};h.ControlPoint=g;h.MockPoint=D;h.shapesMap={rect:k,circle:f,ellipse:a,path:b,image:e};h.types={};return h}(C);B(!0,c.prototype,m.prototype,B(c.prototype,{nonDOMEvents:["add","afterUpdate","drag","remove"],defaultOptions:r}));"";return c});r(c,"masters/modules/annotations.src.js",[c["Core/Globals.js"],c["Extensions/Annotations/Annotation.js"]],function(c,
l){c.Annotation=l;l.compose(c.Chart,c.Pointer,c.SVGRenderer)})});
//# sourceMappingURL=annotations.js.map

/***/ }),

/***/ 61361:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
 Highcharts JS v10.3.3 (2023-01-20)

 X-range series

 (c) 2010-2021 Torstein Honsi, Lars A. V. Cabrera

 License: www.highcharts.com/license
*/
(function(a){ true&&module.exports?(a["default"]=a,module.exports=a): true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(88231)], __WEBPACK_AMD_DEFINE_RESULT__ = (function(h){a(h);a.Highcharts=h;return a}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):0})(function(a){function h(a,b,t,c){a.hasOwnProperty(b)||(a[b]=c.apply(null,t),"function"===typeof CustomEvent&&window.dispatchEvent(new CustomEvent("HighchartsModuleLoaded",{detail:{path:b,module:a[b]}})))}a=a?a._modules:{};h(a,"Series/XRange/XRangeSeriesDefaults.js",
[a["Core/Utilities.js"]],function(a){var b=a.correctFloat,q=a.isNumber,c=a.isObject;"";return{colorByPoint:!0,dataLabels:{formatter:function(){var a=this.point.partialFill;c(a)&&(a=a.amount);if(q(a)&&0<a)return b(100*a)+"%"},inside:!0,verticalAlign:"middle"},tooltip:{headerFormat:'<span style="font-size: 10px">{point.x} - {point.x2}</span><br/>',pointFormat:'<span style="color:{point.color}">\u25cf</span> {series.name}: <b>{point.yCategory}</b><br/>'},borderRadius:3,pointRange:0}});h(a,"Series/XRange/XRangePoint.js",
[a["Core/Series/SeriesRegistry.js"],a["Core/Utilities.js"]],function(a,b){var q=this&&this.__extends||function(){var a=function(c,f){a=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(a,f){a.__proto__=f}||function(a,f){for(var c in f)f.hasOwnProperty(c)&&(a[c]=f[c])};return a(c,f)};return function(c,f){function b(){this.constructor=c}a(c,f);c.prototype=null===f?Object.create(f):(b.prototype=f.prototype,new b)}}(),c=a.series.prototype.pointClass.prototype;b=b.extend;a=function(a){function b(){var f=
null!==a&&a.apply(this,arguments)||this;f.options=void 0;f.series=void 0;return f}q(b,a);b.getColorByCategory=function(a,c){var b=a.options.colors||a.chart.options.colors;a=c.y%(b?b.length:a.chart.options.chart.colorCount);return{colorIndex:a,color:b&&b[a]}};b.prototype.resolveColor=function(){var a=this.series;if(a.options.colorByPoint&&!this.options.color){var c=b.getColorByCategory(a,this);a.chart.styledMode||(this.color=c.color);this.options.colorIndex||(this.colorIndex=c.colorIndex)}else this.color||
(this.color=a.color)};b.prototype.init=function(){c.init.apply(this,arguments);this.y||(this.y=0);return this};b.prototype.setState=function(){c.setState.apply(this,arguments);this.series.drawPoint(this,this.series.getAnimationVerb())};b.prototype.getLabelConfig=function(){var a=c.getLabelConfig.call(this),b=this.series.yAxis.categories;a.x2=this.x2;a.yCategory=this.yCategory=b&&b[this.y];return a};b.prototype.isValid=function(){return"number"===typeof this.x&&"number"===typeof this.x2};return b}(a.seriesTypes.column.prototype.pointClass);
b(a.prototype,{ttBelow:!1,tooltipDateKeys:["x","x2"]});"";return a});h(a,"Series/XRange/XRangeSeries.js",[a["Core/Globals.js"],a["Core/Color/Color.js"],a["Core/Series/SeriesRegistry.js"],a["Core/Utilities.js"],a["Series/XRange/XRangeSeriesDefaults.js"],a["Series/XRange/XRangePoint.js"]],function(a,b,h,c,F,G){function f(){if(this.isXAxis){var a=v(this.dataMax,-Number.MAX_VALUE);for(var b=0,d=this.series;b<d.length;b++){var g=d[b];if(g.x2Data){var y=0;for(g=g.x2Data;y<g.length;y++){var c=g[y];if(c&&
c>a){a=c;var e=!0}}}}e&&(this.dataMax=a)}}var q=this&&this.__extends||function(){var a=function(b,d){a=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(a,d){a.__proto__=d}||function(a,d){for(var g in d)d.hasOwnProperty(g)&&(a[g]=d[g])};return a(b,d)};return function(b,d){function g(){this.constructor=b}a(b,d);b.prototype=null===d?Object.create(d):(g.prototype=d.prototype,new g)}}();a=a.noop;var A=b.parse,B=h.series.prototype,C=h.seriesTypes.column,t=c.addEvent,w=c.clamp,I=c.defined;
b=c.extend;var D=c.find,x=c.isNumber,z=c.isObject,u=c.merge,v=c.pick,E=[];c=function(a){function b(){var d=null!==a&&a.apply(this,arguments)||this;d.data=void 0;d.options=void 0;d.points=void 0;return d}q(b,a);b.compose=function(a){-1===E.indexOf(a)&&(E.push(a),t(a,"afterGetSeriesExtremes",f))};b.prototype.init=function(){a.prototype.init.apply(this,arguments);this.options.stacking=void 0};b.prototype.getColumnMetrics=function(){var d=this,b=function(){for(var a=0,b=d.chart.series;a<b.length;a++){var g=
b[a],c=g.xAxis;g.xAxis=g.yAxis;g.yAxis=c}};b();var c=a.prototype.getColumnMetrics.call(this);b();return c};b.prototype.cropData=function(a,b,c,H){b=B.cropData.call(this,this.x2Data,b,c,H);b.xData=a.slice(b.start,b.end);return b};b.prototype.findPointIndex=function(a){var d=this.cropStart,b=this.points,c=a.id;if(c)var e=(e=D(b,function(a){return a.id===c}))?e.index:void 0;"undefined"===typeof e&&(e=(e=D(b,function(d){return d.x===a.x&&d.x2===a.x2&&!d.touched}))?e.index:void 0);this.cropped&&x(e)&&
x(d)&&e>=d&&(e-=d);return e};b.prototype.alignDataLabel=function(d){var b=d.plotX;d.plotX=v(d.dlBox&&d.dlBox.centerX,d.plotX);a.prototype.alignDataLabel.apply(this,arguments);d.plotX=b};b.prototype.translatePoint=function(a){var b=this.xAxis,d=this.yAxis,c=this.columnMetrics,e=this.options,f=e.minPointLength||0,p=(a.shapeArgs&&a.shapeArgs.width||0)/2,m=this.pointXOffset=c.offset,h=v(a.x2,a.x+(a.len||0)),l=a.plotX,n=b.translate(h,0,0,0,1);h=Math.abs(n-l);var q=this.chart.inverted,k=v(e.borderWidth,
1)%2/2,r=c.offset,t=Math.round(c.width);f&&(f-=h,0>f&&(f=0),l-=f/2,n+=f/2);l=Math.max(l,-10);n=w(n,-10,b.len+10);I(a.options.pointWidth)&&(r-=(Math.ceil(a.options.pointWidth)-t)/2,t=Math.ceil(a.options.pointWidth));e.pointPlacement&&x(a.plotY)&&d.categories&&(a.plotY=d.translate(a.y,0,1,0,1,e.pointPlacement));e=Math.floor(Math.min(l,n))+k;e={x:e,y:Math.floor(a.plotY+r)+k,width:Math.floor(Math.max(l,n))+k-e,height:t,r:this.options.borderRadius};a.shapeArgs=e;q?a.tooltipPos[1]+=m+p:a.tooltipPos[0]-=
p+m-e.width/2;p=e.x;m=p+e.width;0>p||m>b.len?(p=w(p,0,b.len),m=w(m,0,b.len),n=m-p,a.dlBox=u(e,{x:p,width:m-p,centerX:n?n/2:null})):a.dlBox=null;p=a.tooltipPos;m=q?1:0;n=q?0:1;c=this.columnMetrics?this.columnMetrics.offset:-c.width/2;p[m]=q?p[m]+e.width/2:p[m]+(b.reversed?-1:0)*e.width;p[n]=w(p[n]+(q?-1:1)*c,0,d.len-1);if(d=a.partialFill)z(d)&&(d=d.amount),x(d)||(d=0),a.partShapeArgs=u(e,{r:this.options.borderRadius}),l=Math.max(Math.round(h*d+a.plotX-l),0),a.clipRectArgs={x:b.reversed?e.x+h-l:e.x,
y:e.y,width:l,height:e.height}};b.prototype.translate=function(){a.prototype.translate.apply(this,arguments);for(var b=0,c=this.points;b<c.length;b++)this.translatePoint(c[b])};b.prototype.drawPoint=function(a,b){var c=this.options,d=this.chart.renderer,e=a.shapeType,f=a.shapeArgs,g=a.partShapeArgs,m=a.clipRectArgs,h=c.stacking&&!c.borderRadius,l=a.state,n=c.states[l||"normal"]||{},q="undefined"===typeof l?"attr":b;l=this.pointAttribs(a,l);n=v(this.chart.options.chart.animation,n.animation);var k=
a.graphic,r=a.partialFill;if(a.isNull||!1===a.visible)k&&(a.graphic=k.destroy());else{if(k)k.rect[b](f);else a.graphic=k=d.g("point").addClass(a.getClassName()).add(a.group||this.group),k.rect=d[e](u(f)).addClass(a.getClassName()).addClass("highcharts-partfill-original").add(k);g&&(k.partRect?(k.partRect[b](u(g)),k.partialClipRect[b](u(m))):(k.partialClipRect=d.clipRect(m.x,m.y,m.width,m.height),k.partRect=d[e](g).addClass("highcharts-partfill-overlay").add(k).clip(k.partialClipRect)));this.chart.styledMode||
(k.rect[b](l,n).shadow(c.shadow,null,h),g&&(z(r)||(r={}),z(c.partialFill)&&(r=u(c.partialFill,r)),a=r.fill||A(l.fill).brighten(-.3).get()||A(a.color||this.color).brighten(-.3).get(),l.fill=a,k.partRect[q](l,n).shadow(c.shadow,null,h)))}};b.prototype.drawPoints=function(){for(var a=this.getAnimationVerb(),b=0,c=this.points;b<c.length;b++)this.drawPoint(c[b],a)};b.prototype.getAnimationVerb=function(){return this.chart.pointCount<(this.options.animationLimit||250)?"animate":"attr"};b.prototype.isPointInside=
function(b){var c=b.shapeArgs,d=b.plotX,f=b.plotY;return c?"undefined"!==typeof d&&"undefined"!==typeof f&&0<=f&&f<=this.yAxis.len&&0<=(c.x||0)+(c.width||0)&&d<=this.xAxis.len:a.prototype.isPointInside.apply(this,arguments)};b.defaultOptions=u(C.defaultOptions,F);return b}(C);b(c.prototype,{pointClass:G,cropShoulder:1,getExtremesFromAll:!0,parallelArrays:["x","x2","y"],requireSorting:!1,type:"xrange",animate:B.animate,autoIncrement:a,buildKDTree:a});h.registerSeriesType("xrange",c);return c});h(a,
"masters/modules/xrange.src.js",[a["Core/Globals.js"],a["Series/XRange/XRangeSeries.js"]],function(a,b){b.compose(a.Axis)})});
//# sourceMappingURL=xrange.js.map

/***/ }),

/***/ 32586:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHas(object, key) {
  return object != null && hasOwnProperty.call(object, key);
}

module.exports = baseHas;


/***/ }),

/***/ 78068:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseEach = __webpack_require__(61701),
    isArrayLike = __webpack_require__(30568);

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

module.exports = baseMap;


/***/ }),

/***/ 54466:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayMap = __webpack_require__(29233),
    baseGet = __webpack_require__(40548),
    baseIteratee = __webpack_require__(55833),
    baseMap = __webpack_require__(78068),
    baseSortBy = __webpack_require__(53340),
    baseUnary = __webpack_require__(31525),
    compareMultiple = __webpack_require__(20315),
    identity = __webpack_require__(80229),
    isArray = __webpack_require__(55589);

/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */
function baseOrderBy(collection, iteratees, orders) {
  if (iteratees.length) {
    iteratees = arrayMap(iteratees, function(iteratee) {
      if (isArray(iteratee)) {
        return function(value) {
          return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        }
      }
      return iteratee;
    });
  } else {
    iteratees = [identity];
  }

  var index = -1;
  iteratees = arrayMap(iteratees, baseUnary(baseIteratee));

  var result = baseMap(collection, function(value, key, collection) {
    var criteria = arrayMap(iteratees, function(iteratee) {
      return iteratee(value);
    });
    return { 'criteria': criteria, 'index': ++index, 'value': value };
  });

  return baseSortBy(result, function(object, other) {
    return compareMultiple(object, other, orders);
  });
}

module.exports = baseOrderBy;


/***/ }),

/***/ 53340:
/***/ (function(module) {

/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */
function baseSortBy(array, comparer) {
  var length = array.length;

  array.sort(comparer);
  while (length--) {
    array[length] = array[length].value;
  }
  return array;
}

module.exports = baseSortBy;


/***/ }),

/***/ 21656:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(62438);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),

/***/ 88899:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isSymbol = __webpack_require__(52624);

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */
function compareAscending(value, other) {
  if (value !== other) {
    var valIsDefined = value !== undefined,
        valIsNull = value === null,
        valIsReflexive = value === value,
        valIsSymbol = isSymbol(value);

    var othIsDefined = other !== undefined,
        othIsNull = other === null,
        othIsReflexive = other === other,
        othIsSymbol = isSymbol(other);

    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
        (valIsNull && othIsDefined && othIsReflexive) ||
        (!valIsDefined && othIsReflexive) ||
        !valIsReflexive) {
      return 1;
    }
    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
        (othIsNull && valIsDefined && valIsReflexive) ||
        (!othIsDefined && valIsReflexive) ||
        !othIsReflexive) {
      return -1;
    }
  }
  return 0;
}

module.exports = compareAscending;


/***/ }),

/***/ 20315:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var compareAscending = __webpack_require__(88899);

/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */
function compareMultiple(object, other, orders) {
  var index = -1,
      objCriteria = object.criteria,
      othCriteria = other.criteria,
      length = objCriteria.length,
      ordersLength = orders.length;

  while (++index < length) {
    var result = compareAscending(objCriteria[index], othCriteria[index]);
    if (result) {
      if (index >= ordersLength) {
        return result;
      }
      var order = orders[index];
      return result * (order == 'desc' ? -1 : 1);
    }
  }
  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
  // that causes it, under certain circumstances, to provide the same value for
  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
  // for more details.
  //
  // This also ensures a stable sort in V8 and other engines.
  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
  return object.index - other.index;
}

module.exports = compareMultiple;


/***/ }),

/***/ 62438:
/***/ (function(module) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),

/***/ 71974:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(44770),
    baseIteratee = __webpack_require__(55833),
    toInteger = __webpack_require__(96843);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * This method is like `_.findIndex` except that it iterates over elements
 * of `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=array.length-1] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': true },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': false }
 * ];
 *
 * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
 * // => 2
 *
 * // The `_.matches` iteratee shorthand.
 * _.findLastIndex(users, { 'user': 'barney', 'active': true });
 * // => 0
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findLastIndex(users, ['active', false]);
 * // => 2
 *
 * // The `_.property` iteratee shorthand.
 * _.findLastIndex(users, 'active');
 * // => 0
 */
function findLastIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = length - 1;
  if (fromIndex !== undefined) {
    index = toInteger(fromIndex);
    index = fromIndex < 0
      ? nativeMax(length + index, 0)
      : nativeMin(index, length - 1);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index, true);
}

module.exports = findLastIndex;


/***/ }),

/***/ 45346:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseHas = __webpack_require__(32586),
    hasPath = __webpack_require__(13544);

/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */
function has(object, path) {
  return object != null && hasPath(object, path, baseHas);
}

module.exports = has;


/***/ }),

/***/ 50663:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createAggregator = __webpack_require__(17325);

/**
 * Creates an array of elements split into two groups, the first of which
 * contains elements `predicate` returns truthy for, the second of which
 * contains elements `predicate` returns falsey for. The predicate is
 * invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the array of grouped elements.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': false },
 *   { 'user': 'fred',    'age': 40, 'active': true },
 *   { 'user': 'pebbles', 'age': 1,  'active': false }
 * ];
 *
 * _.partition(users, function(o) { return o.active; });
 * // => objects for [['fred'], ['barney', 'pebbles']]
 *
 * // The `_.matches` iteratee shorthand.
 * _.partition(users, { 'age': 1, 'active': false });
 * // => objects for [['pebbles'], ['barney', 'fred']]
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.partition(users, ['active', false]);
 * // => objects for [['barney', 'pebbles'], ['fred']]
 *
 * // The `_.property` iteratee shorthand.
 * _.partition(users, 'active');
 * // => objects for [['fred'], ['barney', 'pebbles']]
 */
var partition = createAggregator(function(result, value, key) {
  result[key ? 0 : 1].push(value);
}, function() { return [[], []]; });

module.exports = partition;


/***/ }),

/***/ 71635:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseFlatten = __webpack_require__(22825),
    baseOrderBy = __webpack_require__(54466),
    baseRest = __webpack_require__(29735),
    isIterateeCall = __webpack_require__(98132);

/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */
var sortBy = baseRest(function(collection, iteratees) {
  if (collection == null) {
    return [];
  }
  var length = iteratees.length;
  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
    iteratees = [];
  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
    iteratees = [iteratees[0]];
  }
  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
});

module.exports = sortBy;


/***/ }),

/***/ 99558:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toNumber = __webpack_require__(29153);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),

/***/ 96843:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toFinite = __webpack_require__(99558);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),

/***/ 29153:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTrim = __webpack_require__(21656),
    isObject = __webpack_require__(93702),
    isSymbol = __webpack_require__(52624);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),

/***/ 3010:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIteratee = __webpack_require__(55833),
    baseUniq = __webpack_require__(80135);

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */
function uniqBy(array, iteratee) {
  return (array && array.length) ? baseUniq(array, baseIteratee(iteratee, 2)) : [];
}

module.exports = uniqBy;


/***/ }),

/***/ 29416:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


// A linked list to keep track of recently-used-ness
const Yallist = __webpack_require__(87406)

const MAX = Symbol('max')
const LENGTH = Symbol('length')
const LENGTH_CALCULATOR = Symbol('lengthCalculator')
const ALLOW_STALE = Symbol('allowStale')
const MAX_AGE = Symbol('maxAge')
const DISPOSE = Symbol('dispose')
const NO_DISPOSE_ON_SET = Symbol('noDisposeOnSet')
const LRU_LIST = Symbol('lruList')
const CACHE = Symbol('cache')
const UPDATE_AGE_ON_GET = Symbol('updateAgeOnGet')

const naiveLength = () => 1

// lruList is a yallist where the head is the youngest
// item, and the tail is the oldest.  the list contains the Hit
// objects as the entries.
// Each Hit object has a reference to its Yallist.Node.  This
// never changes.
//
// cache is a Map (or PseudoMap) that matches the keys to
// the Yallist.Node object.
class LRUCache {
  constructor (options) {
    if (typeof options === 'number')
      options = { max: options }

    if (!options)
      options = {}

    if (options.max && (typeof options.max !== 'number' || options.max < 0))
      throw new TypeError('max must be a non-negative number')
    // Kind of weird to have a default max of Infinity, but oh well.
    const max = this[MAX] = options.max || Infinity

    const lc = options.length || naiveLength
    this[LENGTH_CALCULATOR] = (typeof lc !== 'function') ? naiveLength : lc
    this[ALLOW_STALE] = options.stale || false
    if (options.maxAge && typeof options.maxAge !== 'number')
      throw new TypeError('maxAge must be a number')
    this[MAX_AGE] = options.maxAge || 0
    this[DISPOSE] = options.dispose
    this[NO_DISPOSE_ON_SET] = options.noDisposeOnSet || false
    this[UPDATE_AGE_ON_GET] = options.updateAgeOnGet || false
    this.reset()
  }

  // resize the cache when the max changes.
  set max (mL) {
    if (typeof mL !== 'number' || mL < 0)
      throw new TypeError('max must be a non-negative number')

    this[MAX] = mL || Infinity
    trim(this)
  }
  get max () {
    return this[MAX]
  }

  set allowStale (allowStale) {
    this[ALLOW_STALE] = !!allowStale
  }
  get allowStale () {
    return this[ALLOW_STALE]
  }

  set maxAge (mA) {
    if (typeof mA !== 'number')
      throw new TypeError('maxAge must be a non-negative number')

    this[MAX_AGE] = mA
    trim(this)
  }
  get maxAge () {
    return this[MAX_AGE]
  }

  // resize the cache when the lengthCalculator changes.
  set lengthCalculator (lC) {
    if (typeof lC !== 'function')
      lC = naiveLength

    if (lC !== this[LENGTH_CALCULATOR]) {
      this[LENGTH_CALCULATOR] = lC
      this[LENGTH] = 0
      this[LRU_LIST].forEach(hit => {
        hit.length = this[LENGTH_CALCULATOR](hit.value, hit.key)
        this[LENGTH] += hit.length
      })
    }
    trim(this)
  }
  get lengthCalculator () { return this[LENGTH_CALCULATOR] }

  get length () { return this[LENGTH] }
  get itemCount () { return this[LRU_LIST].length }

  rforEach (fn, thisp) {
    thisp = thisp || this
    for (let walker = this[LRU_LIST].tail; walker !== null;) {
      const prev = walker.prev
      forEachStep(this, fn, walker, thisp)
      walker = prev
    }
  }

  forEach (fn, thisp) {
    thisp = thisp || this
    for (let walker = this[LRU_LIST].head; walker !== null;) {
      const next = walker.next
      forEachStep(this, fn, walker, thisp)
      walker = next
    }
  }

  keys () {
    return this[LRU_LIST].toArray().map(k => k.key)
  }

  values () {
    return this[LRU_LIST].toArray().map(k => k.value)
  }

  reset () {
    if (this[DISPOSE] &&
        this[LRU_LIST] &&
        this[LRU_LIST].length) {
      this[LRU_LIST].forEach(hit => this[DISPOSE](hit.key, hit.value))
    }

    this[CACHE] = new Map() // hash of items by key
    this[LRU_LIST] = new Yallist() // list of items in order of use recency
    this[LENGTH] = 0 // length of items in the list
  }

  dump () {
    return this[LRU_LIST].map(hit =>
      isStale(this, hit) ? false : {
        k: hit.key,
        v: hit.value,
        e: hit.now + (hit.maxAge || 0)
      }).toArray().filter(h => h)
  }

  dumpLru () {
    return this[LRU_LIST]
  }

  set (key, value, maxAge) {
    maxAge = maxAge || this[MAX_AGE]

    if (maxAge && typeof maxAge !== 'number')
      throw new TypeError('maxAge must be a number')

    const now = maxAge ? Date.now() : 0
    const len = this[LENGTH_CALCULATOR](value, key)

    if (this[CACHE].has(key)) {
      if (len > this[MAX]) {
        del(this, this[CACHE].get(key))
        return false
      }

      const node = this[CACHE].get(key)
      const item = node.value

      // dispose of the old one before overwriting
      // split out into 2 ifs for better coverage tracking
      if (this[DISPOSE]) {
        if (!this[NO_DISPOSE_ON_SET])
          this[DISPOSE](key, item.value)
      }

      item.now = now
      item.maxAge = maxAge
      item.value = value
      this[LENGTH] += len - item.length
      item.length = len
      this.get(key)
      trim(this)
      return true
    }

    const hit = new Entry(key, value, len, now, maxAge)

    // oversized objects fall out of cache automatically.
    if (hit.length > this[MAX]) {
      if (this[DISPOSE])
        this[DISPOSE](key, value)

      return false
    }

    this[LENGTH] += hit.length
    this[LRU_LIST].unshift(hit)
    this[CACHE].set(key, this[LRU_LIST].head)
    trim(this)
    return true
  }

  has (key) {
    if (!this[CACHE].has(key)) return false
    const hit = this[CACHE].get(key).value
    return !isStale(this, hit)
  }

  get (key) {
    return get(this, key, true)
  }

  peek (key) {
    return get(this, key, false)
  }

  pop () {
    const node = this[LRU_LIST].tail
    if (!node)
      return null

    del(this, node)
    return node.value
  }

  del (key) {
    del(this, this[CACHE].get(key))
  }

  load (arr) {
    // reset the cache
    this.reset()

    const now = Date.now()
    // A previous serialized cache has the most recent items first
    for (let l = arr.length - 1; l >= 0; l--) {
      const hit = arr[l]
      const expiresAt = hit.e || 0
      if (expiresAt === 0)
        // the item was created without expiration in a non aged cache
        this.set(hit.k, hit.v)
      else {
        const maxAge = expiresAt - now
        // dont add already expired items
        if (maxAge > 0) {
          this.set(hit.k, hit.v, maxAge)
        }
      }
    }
  }

  prune () {
    this[CACHE].forEach((value, key) => get(this, key, false))
  }
}

const get = (self, key, doUse) => {
  const node = self[CACHE].get(key)
  if (node) {
    const hit = node.value
    if (isStale(self, hit)) {
      del(self, node)
      if (!self[ALLOW_STALE])
        return undefined
    } else {
      if (doUse) {
        if (self[UPDATE_AGE_ON_GET])
          node.value.now = Date.now()
        self[LRU_LIST].unshiftNode(node)
      }
    }
    return hit.value
  }
}

const isStale = (self, hit) => {
  if (!hit || (!hit.maxAge && !self[MAX_AGE]))
    return false

  const diff = Date.now() - hit.now
  return hit.maxAge ? diff > hit.maxAge
    : self[MAX_AGE] && (diff > self[MAX_AGE])
}

const trim = self => {
  if (self[LENGTH] > self[MAX]) {
    for (let walker = self[LRU_LIST].tail;
      self[LENGTH] > self[MAX] && walker !== null;) {
      // We know that we're about to delete this one, and also
      // what the next least recently used key will be, so just
      // go ahead and set it now.
      const prev = walker.prev
      del(self, walker)
      walker = prev
    }
  }
}

const del = (self, node) => {
  if (node) {
    const hit = node.value
    if (self[DISPOSE])
      self[DISPOSE](hit.key, hit.value)

    self[LENGTH] -= hit.length
    self[CACHE].delete(hit.key)
    self[LRU_LIST].removeNode(node)
  }
}

class Entry {
  constructor (key, value, length, now, maxAge) {
    this.key = key
    this.value = value
    this.length = length
    this.now = now
    this.maxAge = maxAge || 0
  }
}

const forEachStep = (self, fn, node, thisp) => {
  let hit = node.value
  if (isStale(self, hit)) {
    del(self, node)
    if (!self[ALLOW_STALE])
      hit = undefined
  }
  if (hit)
    fn.call(thisp, hit.value, hit.key, self)
}

module.exports = LRUCache


/***/ }),

/***/ 94735:
/***/ (function(module) {

"use strict";

module.exports = function (Yallist) {
  Yallist.prototype[Symbol.iterator] = function* () {
    for (let walker = this.head; walker; walker = walker.next) {
      yield walker.value
    }
  }
}


/***/ }),

/***/ 87406:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

module.exports = Yallist

Yallist.Node = Node
Yallist.create = Yallist

function Yallist (list) {
  var self = this
  if (!(self instanceof Yallist)) {
    self = new Yallist()
  }

  self.tail = null
  self.head = null
  self.length = 0

  if (list && typeof list.forEach === 'function') {
    list.forEach(function (item) {
      self.push(item)
    })
  } else if (arguments.length > 0) {
    for (var i = 0, l = arguments.length; i < l; i++) {
      self.push(arguments[i])
    }
  }

  return self
}

Yallist.prototype.removeNode = function (node) {
  if (node.list !== this) {
    throw new Error('removing node which does not belong to this list')
  }

  var next = node.next
  var prev = node.prev

  if (next) {
    next.prev = prev
  }

  if (prev) {
    prev.next = next
  }

  if (node === this.head) {
    this.head = next
  }
  if (node === this.tail) {
    this.tail = prev
  }

  node.list.length--
  node.next = null
  node.prev = null
  node.list = null

  return next
}

Yallist.prototype.unshiftNode = function (node) {
  if (node === this.head) {
    return
  }

  if (node.list) {
    node.list.removeNode(node)
  }

  var head = this.head
  node.list = this
  node.next = head
  if (head) {
    head.prev = node
  }

  this.head = node
  if (!this.tail) {
    this.tail = node
  }
  this.length++
}

Yallist.prototype.pushNode = function (node) {
  if (node === this.tail) {
    return
  }

  if (node.list) {
    node.list.removeNode(node)
  }

  var tail = this.tail
  node.list = this
  node.prev = tail
  if (tail) {
    tail.next = node
  }

  this.tail = node
  if (!this.head) {
    this.head = node
  }
  this.length++
}

Yallist.prototype.push = function () {
  for (var i = 0, l = arguments.length; i < l; i++) {
    push(this, arguments[i])
  }
  return this.length
}

Yallist.prototype.unshift = function () {
  for (var i = 0, l = arguments.length; i < l; i++) {
    unshift(this, arguments[i])
  }
  return this.length
}

Yallist.prototype.pop = function () {
  if (!this.tail) {
    return undefined
  }

  var res = this.tail.value
  this.tail = this.tail.prev
  if (this.tail) {
    this.tail.next = null
  } else {
    this.head = null
  }
  this.length--
  return res
}

Yallist.prototype.shift = function () {
  if (!this.head) {
    return undefined
  }

  var res = this.head.value
  this.head = this.head.next
  if (this.head) {
    this.head.prev = null
  } else {
    this.tail = null
  }
  this.length--
  return res
}

Yallist.prototype.forEach = function (fn, thisp) {
  thisp = thisp || this
  for (var walker = this.head, i = 0; walker !== null; i++) {
    fn.call(thisp, walker.value, i, this)
    walker = walker.next
  }
}

Yallist.prototype.forEachReverse = function (fn, thisp) {
  thisp = thisp || this
  for (var walker = this.tail, i = this.length - 1; walker !== null; i--) {
    fn.call(thisp, walker.value, i, this)
    walker = walker.prev
  }
}

Yallist.prototype.get = function (n) {
  for (var i = 0, walker = this.head; walker !== null && i < n; i++) {
    // abort out of the list early if we hit a cycle
    walker = walker.next
  }
  if (i === n && walker !== null) {
    return walker.value
  }
}

Yallist.prototype.getReverse = function (n) {
  for (var i = 0, walker = this.tail; walker !== null && i < n; i++) {
    // abort out of the list early if we hit a cycle
    walker = walker.prev
  }
  if (i === n && walker !== null) {
    return walker.value
  }
}

Yallist.prototype.map = function (fn, thisp) {
  thisp = thisp || this
  var res = new Yallist()
  for (var walker = this.head; walker !== null;) {
    res.push(fn.call(thisp, walker.value, this))
    walker = walker.next
  }
  return res
}

Yallist.prototype.mapReverse = function (fn, thisp) {
  thisp = thisp || this
  var res = new Yallist()
  for (var walker = this.tail; walker !== null;) {
    res.push(fn.call(thisp, walker.value, this))
    walker = walker.prev
  }
  return res
}

Yallist.prototype.reduce = function (fn, initial) {
  var acc
  var walker = this.head
  if (arguments.length > 1) {
    acc = initial
  } else if (this.head) {
    walker = this.head.next
    acc = this.head.value
  } else {
    throw new TypeError('Reduce of empty list with no initial value')
  }

  for (var i = 0; walker !== null; i++) {
    acc = fn(acc, walker.value, i)
    walker = walker.next
  }

  return acc
}

Yallist.prototype.reduceReverse = function (fn, initial) {
  var acc
  var walker = this.tail
  if (arguments.length > 1) {
    acc = initial
  } else if (this.tail) {
    walker = this.tail.prev
    acc = this.tail.value
  } else {
    throw new TypeError('Reduce of empty list with no initial value')
  }

  for (var i = this.length - 1; walker !== null; i--) {
    acc = fn(acc, walker.value, i)
    walker = walker.prev
  }

  return acc
}

Yallist.prototype.toArray = function () {
  var arr = new Array(this.length)
  for (var i = 0, walker = this.head; walker !== null; i++) {
    arr[i] = walker.value
    walker = walker.next
  }
  return arr
}

Yallist.prototype.toArrayReverse = function () {
  var arr = new Array(this.length)
  for (var i = 0, walker = this.tail; walker !== null; i++) {
    arr[i] = walker.value
    walker = walker.prev
  }
  return arr
}

Yallist.prototype.slice = function (from, to) {
  to = to || this.length
  if (to < 0) {
    to += this.length
  }
  from = from || 0
  if (from < 0) {
    from += this.length
  }
  var ret = new Yallist()
  if (to < from || to < 0) {
    return ret
  }
  if (from < 0) {
    from = 0
  }
  if (to > this.length) {
    to = this.length
  }
  for (var i = 0, walker = this.head; walker !== null && i < from; i++) {
    walker = walker.next
  }
  for (; walker !== null && i < to; i++, walker = walker.next) {
    ret.push(walker.value)
  }
  return ret
}

Yallist.prototype.sliceReverse = function (from, to) {
  to = to || this.length
  if (to < 0) {
    to += this.length
  }
  from = from || 0
  if (from < 0) {
    from += this.length
  }
  var ret = new Yallist()
  if (to < from || to < 0) {
    return ret
  }
  if (from < 0) {
    from = 0
  }
  if (to > this.length) {
    to = this.length
  }
  for (var i = this.length, walker = this.tail; walker !== null && i > to; i--) {
    walker = walker.prev
  }
  for (; walker !== null && i > from; i--, walker = walker.prev) {
    ret.push(walker.value)
  }
  return ret
}

Yallist.prototype.splice = function (start, deleteCount, ...nodes) {
  if (start > this.length) {
    start = this.length - 1
  }
  if (start < 0) {
    start = this.length + start;
  }

  for (var i = 0, walker = this.head; walker !== null && i < start; i++) {
    walker = walker.next
  }

  var ret = []
  for (var i = 0; walker && i < deleteCount; i++) {
    ret.push(walker.value)
    walker = this.removeNode(walker)
  }
  if (walker === null) {
    walker = this.tail
  }

  if (walker !== this.head && walker !== this.tail) {
    walker = walker.prev
  }

  for (var i = 0; i < nodes.length; i++) {
    walker = insert(this, walker, nodes[i])
  }
  return ret;
}

Yallist.prototype.reverse = function () {
  var head = this.head
  var tail = this.tail
  for (var walker = head; walker !== null; walker = walker.prev) {
    var p = walker.prev
    walker.prev = walker.next
    walker.next = p
  }
  this.head = tail
  this.tail = head
  return this
}

function insert (self, node, value) {
  var inserted = node === self.head ?
    new Node(value, null, node, self) :
    new Node(value, node, node.next, self)

  if (inserted.next === null) {
    self.tail = inserted
  }
  if (inserted.prev === null) {
    self.head = inserted
  }

  self.length++

  return inserted
}

function push (self, item) {
  self.tail = new Node(item, self.tail, null, self)
  if (!self.head) {
    self.head = self.tail
  }
  self.length++
}

function unshift (self, item) {
  self.head = new Node(item, null, self.head, self)
  if (!self.tail) {
    self.tail = self.head
  }
  self.length++
}

function Node (value, prev, next, list) {
  if (!(this instanceof Node)) {
    return new Node(value, prev, next, list)
  }

  this.list = list
  this.value = value

  if (prev) {
    prev.next = this
    this.prev = prev
  } else {
    this.prev = null
  }

  if (next) {
    next.prev = this
    this.next = next
  } else {
    this.next = null
  }
}

try {
  // add if support for Symbol.iterator is present
  __webpack_require__(94735)(Yallist)
} catch (er) {}


/***/ }),

/***/ 69648:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _createClass; }
/* harmony export */ });
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}


/***/ })

}]);